import { AfterContentChecked, ChangeDetectorRef, ɵgetHostElement, ChangeDetectionStrategy } from '@angular/core';
import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, } from '@angular/forms';
import { DateRangeService } from '@progress/kendo-angular-dateinputs';
import { ComboBoxComponent, MultiSelectComponent } from '@progress/kendo-angular-dropdowns';
import { TabPosition, TabStripComponent, TabStripTabComponent } from '@progress/kendo-angular-layout';
import { environment } from 'environments/environment';
import moment from 'moment';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { GridColumnMap } from '~/front-models/gridColumnMap';
import { augmentForKendo, DataWithPagingMetadata } from '~/infrastructure/paging';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { SysReceive } from '~/models/administration/sysReceive';
import { UserSummary } from '~/models/administration/user';
import { Chart } from '~/models/chart/chart';
import { CategoryListing, CategorySummary } from '~/models/modules/category';
import { CustomFieldSummary } from '~/models/modules/customField';
import { GridFieldSummary } from '~/models/modules/gridField';
import { GridFieldTextSummary } from '~/models/modules/GridFieldText';
import { StockItemSummary } from '~/models/modules/item';
import { SitesEnum } from '~/shared/enums/sites.enum';
import { StartEndDateChartResponseModel } from '~/models/modules/startEndDateChartResponseModel';
import { QuantityPerLocationChartResponseModel } from '~/models/modules/quantityPerLocationChartResponseModel';
import { StockItemFile } from '~/models/modules/stockItemFile';
import { StockItemVendor } from '~/models/modules/stockItemVendor';
import { StockLocationMinMax } from '~/models/modules/stockLocationMinMax';
import { UnitOfMeasureListing, UnitOfMeasureSummary } from '~/models/modules/unitOfMeasure';
import { VendorSummary } from '~/models/modules/vendor';
import { AccountsService } from '~/services/administration.ts/accounts';
import { AssembleSettingsService } from '~/services/administration.ts/assemble-settings';
import { FormatService } from '~/services/administration.ts/format';
import { QuantityFormatsService } from '~/services/administration.ts/quantity-formats';
import { SysReceivesService } from '~/services/administration.ts/sysReceive';
import { UsersService } from '~/services/administration.ts/users';
import { BarcodeGeneratorsService } from '~/services/modules/stocks/barcode-generators';
import { CategoriesService } from '~/services/modules/stocks/categories';
import { CustomFieldsService } from '~/services/modules/stocks/custom-fields';
import { FilesService } from '~/services/modules/stocks/files';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { StockItemsService } from '~/services/modules/stocks/items';
import { LocationsService } from '~/services/modules/stocks/locations';
import { PurchaseOrdersService } from '~/services/modules/stocks/purchase-orders';
import { SalesOrdersService } from '~/services/modules/stocks/sales-orders';
import { UnitOfMeasuresService } from '~/services/modules/stocks/unit-of-measure';
import { VendorsService } from '~/services/modules/stocks/vendors';
import { SecurityService } from '~/services/security.service';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { PageState } from '~/shared/enums/stock-files.enum';
import { StockDataService } from './stocdata.service';
import { ReceiveTransactionsService } from '~/services/modules/stocks/receive-transactions';
import { IssueTransactionsService } from '~/services/modules/stocks/issue-transaction';
import { InventoriesService } from '~/services/modules/stocks/inventories';
import { StocksDeactivatingDataComponent } from '~/shared/components/deactivate-data/deactivate-data';
import { MultiSiteAwareComponent } from '~/infrastructure/multi-site-aware.component';
import { NoteComponent } from '~/shared/components/note/note.component';
import { LocationSummary } from '~/models/modules/location';
import { GDataService } from '~/services/GDataService';
import { UPCOnlineSettingsService } from '~/services/administration.ts/upc-online-settings';
import { fileSources } from '~/shared/enums/fileSources';
import { EntityStatusOptions } from '~/models/entityStatus';
import { EnvironmentLoaderService } from '~/services/BackEndURL/environment-loader.service';
import { FormatTypes } from '~/shared/enums/FormatTypes';
import { SelectableMode, SelectableSettings } from '@progress/kendo-angular-grid';
import { MultiSiteService } from '~/services/modules/common/multi-site.service';

@Component({
    selector: 'stockitem-form',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [DateRangeService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StocksItemsUpsertComponent
  extends MultiSiteAwareComponent
  implements OnInit, OnDestroy, AfterContentChecked {
  _deactivatedFormTabsForm: boolean = false
  _deactivatedFormTabsGridData: Array<any> = [];

  @ViewChild('imageSearch', { static: false }) imageSearchInput: ElementRef;
  @ViewChild('Locationearch', { static: false })
  LocationSearchInput: ElementRef;
  @ViewChild('kendo_tabstrip_wrapper') navTrigger: ElementRef;
  @ViewChild('kendo_BarcodeGen_Stock_Number')
  kendoBarcodeGenStockNumber: ElementRef;
  @ViewChild('Kendo_Combobox_Item_Type')
  kendoComboboxItemType: ComboBoxComponent;
  @ViewChild('Kendo_Combobox_receive_UM')
  KendoComboboxreceiveUM: ComboBoxComponent;
  @ViewChild('Kendo_Combobox_Inventory_UM')
  KendoComboboxInventoryUM: ComboBoxComponent;
  @ViewChild('Kendo_Combobox_Issue_UM') KendoComboboxIssueUM: ComboBoxComponent;
  @ViewChild('Kendo_Combobox_Cost_Type')
  KendoComboboxCostType: ComboBoxComponent;
  @ViewChild('kendo_multiselect_wrapper_Status')
  kendomultiselectwrapperStatus: ElementRef;
  @ViewChild('kendo_multiselect_Status')
  kendoMultiselectStatus: MultiSelectComponent;
  @ViewChild('kendo_multiselect_wrapper_Status_Costing')
  kendomultiselectwrapperStatusCosting: ElementRef;
  @ViewChild('kendo_multiselect_Status_Costing')
  kendoMultiselectStatusCosting: MultiSelectComponent;
  @ViewChild('accountTab') accountTab: TabStripTabComponent;
  @ViewChild('GeneralTab') GeneralTab: TabStripTabComponent;
  @ViewChild('costingTab') costingTab: TabStripTabComponent;
  @ViewChild('stockInfoTab') stockInfoTab: TabStripTabComponent;
  @ViewChild('kittingTab') kittingTab: TabStripTabComponent;

  @ViewChild('alternateStockItemTab')
  alternateStockItemTab: TabStripTabComponent;
  @ViewChild('picturesTab') picturesTab: TabStripTabComponent;
  @ViewChild('vendorsTab') vendorsTab: TabStripTabComponent;
  @ViewChild('HistoricalDataTab') HistoricalDataTab: TabStripTabComponent;
  @ViewChild('PendingPOTab') PendingPOTab: TabStripTabComponent;
  @ViewChild('PendingSOTab') PendingSOTab: TabStripTabComponent;
  @ViewChild('PendingTransferRequest')
  PendingTransferRequest: TabStripTabComponent;
  @ViewChild('kendo_stock_description_input')
  kendoStockDescriptionInput: ElementRef;
  @ViewChild('mainWindow') kendoMainWindow: ElementRef;
  @ViewChild('anchor') _anchor: ElementRef;
  @ViewChild('note') note: NoteComponent;

  @ViewChild('kendo_combo_vendors') kendoComboVendors: ComboBoxComponent;
  @ViewChild('kendo_combo_items') kendoComboItems: ComboBoxComponent;

  @ViewChild('tabstrip') public tabstrip: TabStripComponent;

  _model: StockItemSummary = null;
  copyModelId: number;

  _isLiveEnterprise: boolean;
  _currentUser: UserSummary;
  _currentStatusvalue: Array<any>;
  _currentStatusCostingvalue: Array<any>;
  selected: string;
  _page = 'stockItems';
  _permissionScope = 'stockItems';
  ShowCategoryForm: boolean = false;
  _itemStatus: Array<any> = [
    {
      id: 'regular',
      title: 'Default',
    },
    // {
    //   id: 'assemble',
    //   title: 'Assemble',
    // },
    {
      id: 'shoppingcart',
      title: 'Shopping Cart',
    },
  ];
  _itemStatusCosting: Array<any> = [
    {
      id: 'fixedprice',
      title: 'Fixed Price',
    },
    {
      id: 'calculateprice',
      title: 'Calculate Price',
    },
  ];

  _selectedItemStatus: any[] = [];
  _selectedItemStatusCosting: any;
  _kendoTabStripPosition: TabPosition = 'left';
  _innerWidth: any;
  _hiddenWindow: any;
  _maximized: any;
  _accountColumnsMap: GridColumnMap[] = [];
  _imageColumnsMap: GridColumnMap[] = [];
  _selectedAccounts: any[] = [];
  _selectedAccountIds: any[] = [];
  _selectedImages: any[] = [];
  _selectedImagesKeys: number[] = [];
  _selectedUpsertImagesKeys: number[] = [];
  _selectedObjectImages: any[] = [];
  _selectedDocuments: any[] = [];
  _selectedDocumentsKeys: number[] = [];
  _selectedObjectDocuments: any[] = [];
  _selectedVendors: any[] = [];
  _selectedVendorsKeys: number[] = [];
  _selectedObjectVendors: any[] = [];
  _selectedObjectLocationMinMax: any[] = [];
  _selectedStockAlternates: any[] = [];
  _selectedStockAlternatesKeys: any[];
  _selectedStockSiteMinMax: any[] = [];
  _theme: string;
  _form: FormGroup;
  _vendorForm: FormGroup;
  _stockAlternateForm: FormGroup;
  _active: boolean;
  _isAutoGeneratingNumber: boolean;
  _custominvalidForm: boolean = false;
  _invalidSubmit: boolean;
  _showImagesGrid: boolean;
  _showDocumentGrid: boolean;
  _showLocationMinMax: boolean;
  _showCirclesForm: boolean;
  _showVendorsGrid: boolean;
  _vendors: VendorSummary[] = [];
  _commonVendors: VendorSummary[] = [];
  _vendorsFiltered: VendorSummary[];
  _categories: CategoryListing[];
  _categoriesFiltered: CategoryListing[];
  _unitOfMeasures: UnitOfMeasureListing[];
  _receiveUnitOfMeasuresFiltered: UnitOfMeasureListing[];
  _receiveDefaultLocation: any[];
  _inventoryUnitOfMeasuresFiltered: UnitOfMeasureListing[];
  _issueUnitOfMeasuresFiltered: UnitOfMeasureListing[];
  _itemTypes: any[];
  _costTypes: any[];
  _customFields: CustomFieldSummary[][] = [];
  _customFieldsDictionary: { [key: string]: string } = {};
  _customFieldsValue: any = [];
  _customValidation: any = [];
  _additionalErrors: any = [];
  _isOs: boolean;
  _addClassActive: boolean = false;
  _tooltipVisibilityUpsert: boolean = true;
  _tooltipVisibilityForm: boolean = true;
  _locations: any[];
  _locationsFiltered: any[];
  _selectedTabId: number;
  _selectedLabelId: number;
  _orderingTabsForm: boolean = false;
  _sysReceiveSettings: SysReceive;
  _loggedInAccountId: number;
  _loggedInSiteId: any;
  _isKit: boolean = false;
  _isShopping: boolean = false;
  _shoppingUM: string;

  _applayTotalExtendedCost: boolean = false;
  _allowSubstituteStock: boolean = false;

  FCostStatus: FormControl = new FormControl();

  isInvalidMinMax: boolean = false;

  _showBillWindow: boolean = false;
  _showBillDetailWindow: boolean = false;

  _showStocksGrid: boolean = false;
  _selectedStocks: StockItemSummary[] = [];

  _stockItemsGridColumns: GridFieldSummary[];

  costPriceFormatType: FormatTypes = FormatTypes.CostandPriceFormat;
  quantityFormatType: FormatTypes = FormatTypes.QuantityFormat;
  //add leadtime compobox
  _leadTimeCombobox: string[] = ['Hours', 'Days', 'Weeks', 'Months', 'Years'];

  public _donutChartSmall: any[] = [
    {
      data: [
        {
          category: 'Site 1',
          value: 120,
          color: '#fff6d9',
          colorLabel: '#ae8d2a',
          font: '10px -apple-system, BlinkMacSystemFont',
        },
        {
          category: 'Site 2',
          value: 90,
          color: '#f2e2b1',
          colorLabel: '#ae8d2a',
          font: '10px -apple-system, BlinkMacSystemFont',
        },
      ],
      sum: 210,
      title: 'DC Health',
    },
    {
      data: [
        {
          category: 'Site 1',
          value: 30,
          color: '#e7e0fc',
          colorLabel: '#321982',
          font: '10px -apple-system, BlinkMacSystemFont',
        },
        {
          category: 'Site 2',
          value: 40,
          color: '#d1c7f0',
          colorLabel: '#321982',
          font: '10px -apple-system, BlinkMacSystemFont',
        },
        {
          category: 'Site 3',
          value: 120,
          color: '#b3a5e3',
          colorLabel: '#321982',
          font: '10px -apple-system, BlinkMacSystemFont',
        },
      ],
      sum: 180,
      title: 'Safe Workplace',
    },
    {
      data: [
        {
          category: 'Site 1',
          value: 30,
          color: '#e5fadd',
          colorLabel: '#458032',
          font: '10px -apple-system, BlinkMacSystemFont',
        },
        {
          category: 'Site 2',
          value: 120,
          color: '#abd59d',
          colorLabel: '#458032',
          font: '10px -apple-system, BlinkMacSystemFont',
        },
      ],
      sum: 150,
      title: 'District Logistics Center',
    },
  ];

  public _donutChartLarge: any[] = [
    {
      data: [
        {
          category: 'Site 1',
          value: 30,
          color: '#e5fadd',
          colorLabel: '#458032',
          font: '15px -apple-system, BlinkMacSystemFont',
        },
        {
          category: 'Site 2',
          value: 120,
          color: '#abd59d',
          colorLabel: '#458032',
          font: '15px -apple-system, BlinkMacSystemFont',
        },
      ],
      sum: 150,
      title: 'District Logistics Center',
    },
    {
      data: [
        {
          category: 'Site 1',
          value: 30,
          color: '#e7e0fc',
          colorLabel: '#321982',
          font: '15px -apple-system, BlinkMacSystemFont',
        },
        {
          category: 'Site 2',
          value: 40,
          color: '#d1c7f0',
          colorLabel: '#321982',
          font: '15px -apple-system, BlinkMacSystemFont',
        },
        {
          category: 'Site 3',
          value: 120,
          color: '#b3a5e3',
          colorLabel: '#321982',
          font: '15px -apple-system, BlinkMacSystemFont',
        },
      ],
      sum: 180,
      title: 'Safe Workplace',
    },
    {
      data: [
        {
          category: 'Site 1',
          value: 120,
          color: '#fff6d9',
          colorLabel: '#ae8d2a',
          font: '15px -apple-system, BlinkMacSystemFont',
        },
        {
          category: 'Site 2',
          value: 90,
          color: '#f2e2b1',
          colorLabel: '#ae8d2a',
          font: '15px -apple-system, BlinkMacSystemFont',
        },
      ],
      sum: 210,
      title: 'DC Health',
    },
  ];
  _listOfLeadVars: Array<string> = [
    'Hours',
    'Days',
    'Weeks',
    'Months',
    'Years',
  ];

  public _POStatsGridData: any[] = [
    {
      PONumber: '001785',
      date: '03/04/2021',
      vendor: 'Vendor 1',
      total: '0.00',
      status: 'Pending 1st Approver',
      subtotal: '0.00',
    },
    {
      PONumber: '001785',
      date: '01/25/2021',
      vendor: 'Vendor 2',
      total: '0.00',
      status: 'Requested',
      subtotal: '47.00',
    },
    {
      PONumber: '001785',
      date: '01/25/2021',
      vendor: 'Vendor 3',
      total: '0.00',
      status: 'Pending 2nd Approver',
      subtotal: '0.25',
    },
    {
      PONumber: '001785',
      date: '01/25/2021',
      vendor: 'Vendor 4',
      total: '0.00',
      status: 'Approved',
      subtotal: '0.00',
    },
  ];
  _isCustomfieldsFormValue: boolean = false;
  _isAddTabFormValue: boolean = false;
  _isRenameFormValue: boolean = false;
  _isRenameCustomFormValue: boolean = false;
  _editFormActive: boolean;
  _customTabFormActive: boolean;
  _renameFormActive: boolean;
  _vendorGridData: any;
  _stockAlternateGridData: any = [];
  // _stockSiteMinMaxGridData: any = [];

  _invalidForm: boolean;
  _imageSearchControl = new FormControl();
  _vendorSearchControl = new FormControl();
  _LocationSearchControl = new FormControl();
  _documentSearchControl = new FormControl();
  _imageSearchResult: string;
  _LocationSearchResult: string;
  _vendorSearchResult: string;
  _documentSearchResult: string;
  _storagePath: string;
  _sitemNumber = new FormControl();
  _itemType = new FormControl();
  _enableAccountSection: boolean = false;
  _pageState: PageState;
  pageState = PageState;
  _POSTabActive: boolean = true;
  _SOSTabActive: boolean = false;
  _POSShartForm: boolean = false;
  _SOSShartForm: boolean = false;
  _MMQTabActive: boolean = false;
  _LSActive: boolean = false;
  _SQActive: boolean = false;
  _StockHistoryActive: boolean = false;

  _index: number;

  _imageTabActive: boolean = false;
  _MMQShartForm: boolean = false;
  _LSChartForm: boolean = false;
  _showimageTab: boolean = false;
  public seriesData: any[] = [];
  public navigatorData: any[] = [];
  public from: Date = new Date('2009/02/05');
  public to: Date = new Date('2011/10/07');
  _gridFieldText: GridFieldTextSummary[];
  _language: string = 'en';
  _customTabs: any;
  _selectedLabelObjectCode: any;
  _isRenameLabel: boolean = false;
  _dataTabs: Array<any> = [];
  _dataTabsSelected: Array<any> = [];
  _isMandatory: boolean = false;
  _locationAuth: GridFieldAuthorization;
  _autoCorrect: boolean = true;

  GeneralSystemFields: Array<any> = [
    { title: 'ItemType' },
    { title: 'ReceiveUM' },
    { title: 'InventoryUM' },
    { title: 'GCategory' },
    { title: 'GeneralDescription' },
    { title: 'ShoppingUM' }
  ];

  costingSystemFields: Array<any> = [
    { title: 'CostType' },
    { title: 'Cost' },
    { title: 'PriceMarkupPer' },
    { title: 'PriceMarkupDol' },
    { title: 'Price' },
    { title: 'CostingStatus' },
  ];

  StockInfoSystemFields: Array<any> = [
    { title: 'MinimumQt' },
    { title: 'MaximumQt' },
    { title: 'LeadTime' },
    { title: 'TimeUnit' },
    { title: 'DefaultLocation' },
  ];

  _systemFields: Array<any> = [];
  _requiredFields: Array<any> = [];
  _customRequiredFields: Array<any> = [];
  _requiredFieldNames: Array<any> = [];
  _editedSystemFields: Array<any> = [];
  _userNewDataTabs: Array<any> = [];
  _gridFieldAuth: GridFieldAuthorization[];
  listPerPOChart: Array<any>;
  poMonths: Array<any> = [];
  poStatus1: Array<any> = [];
  poStatus2: Array<any> = [];
  poStatus3: Array<any> = [];
  poStatus4: Array<any> = [];
  poStatus5: Array<any> = [];
  poStatus6: Array<any> = [];

  listPerSOChart: Array<any>;
  soMonths: Array<any> = [];
  soStatus1: Array<any> = [];
  soStatus2: Array<any> = [];
  soStatus3: Array<any> = [];
  soStatus4: Array<any> = [];
  soStatus5: Array<any> = [];
  soStatus6: Array<any> = [];

  listItemQtyPerLocation: Array<any> = [];
  listLocationQty: any;
  listQtyPerDate: any;
  ListDeLocation: any;
  stockHistory: any;
  listMinMax: any;
  urlAndStream: string;

  okCloseSubscription: any = null;
  _deactivatedFieldsForm: boolean = false;
  _deactivatedFieldsGridData: Array<any> = [];
  _SQChartForm: boolean = false;
  _StockHistoryChartForm: boolean = false;
  _customForm: any;
  _kittingAuth: GridFieldAuthorization;
  _kittingEnabled: boolean;
  _isShopper: boolean;
  _substituteItems: boolean;
  _stockLicense: any;

  _datePickerFormat: string;
  _costFormat: string;
  _dialogComponentName: string;
  _isDialiog: boolean = false;
  _dialogModel: any;

  _isEditForms: boolean = false;
  _primaryStockItemFile: any;

  _isUpc: boolean = false;
  _upcGrid: any;

  _stockItemFilesPics: StockItemFile[] = [];
  _stockItemFilesDoc: StockItemFile[] = [];
  _stockItemFilesVideo: StockItemFile[] = [];
  _selectedObjectVideos: any[] = [];
  _showVideosGrid: boolean = false;
  _videosGridColumns: GridFieldSummary[];
  _stockItemLocationMinMax: StockLocationMinMax[] = [];
  _stockItemVendor: StockItemVendor[] = [];
  _stockVendor: StockItemVendor[] = [];

  quantityFormat: string;
  digitNumber: number;

  stockItemQuantityMinMaxChartDetail: StartEndDateChartResponseModel;
  stockItemQuantityMinMaxChart: Chart;

  poSoChartDetail: StartEndDateChartResponseModel;
  poSoChart: Chart;

  stockItemHistoryDetail: StartEndDateChartResponseModel;
  stockItemHistoryChart: Chart;

  quantityPerLocationChartDetail: QuantityPerLocationChartResponseModel;
  quantityPerLocationChart: Chart;

  _poGridColumns: GridFieldSummary[];
  _soGridColumns: GridFieldSummary[];

  _receiveGridColumns: GridFieldSummary[];
  _issueGridColumns: GridFieldSummary[];

  _inventoriesColumns: GridFieldSummary[];

  isPoSoGridExpanded: boolean = true;
  isPoSoChartExpanded: boolean = true;

  isStockHistoryGridExpanded: boolean = true;
  isStockHistoryChartExpanded: boolean = true;

  isInventoryChartExpanded: boolean = true;
  isInventoryGridExpanded: boolean = true;

  alternativeStockItemCode: string = '';
  alternativeStockItemCodes: string[] = [];

  reactivate: boolean = false;
  reactivateItem: any;

  _users: any;
  IsTaxable: boolean = false;

  _showLocationsGrid: boolean = false;
  _showCategoryGrid: boolean = false;
  _showUOMGrid: boolean = false;
  _showIssueUOMGrid: boolean = false;
  _showInvebtoryUOMGrid: boolean = false;
  _showReceiveUOMGrid: boolean = false;
  _selectedLocations: LocationSummary[] = [];
  _selectedCategories: CategorySummary[] = [];
  _selectedUOM: UnitOfMeasureSummary[] = [];
  _locationsGridColumns: GridFieldSummary[];
  _picturesGridColumns: GridFieldSummary[];
  _documentsGridColumns: GridFieldSummary[];
  _vendorGridColumns: GridFieldSummary[];
  _categoryGridColumns: GridFieldSummary[];
  _uomGridColumns: GridFieldSummary[];
  isUpcOnlineSetting: boolean;
  openfromlist: any;
  theme: string;
  _stockItemData: any;
  _filterdStockItemData: any;
  _stockItemSearchList: any;
  _selectedKitStockItem: any;
  _selectedKitStockItemDetail: any;

  _stockItemsSubstitutes: any;

  _selecttedKitQuantity: number = 0;
  _selecttedKitDetailQuantity: number = 0;
  _selectedKitDefaultLocation: any;
  _selectedKitDetailDefaultLocation: any;
  _selectedKit: any = {};
  _selectedListKit: any = [];
  _selectedListkitDetail: any = [];
  _selectedKitSubList: any = [];
  _selectedShowList: any = [];

  stockItemKitDetails: any = [];
  stockItemSubKitDetails: any = [];

  _selectedCallback = (args: { dataItem: any }) => args.dataItem;
  //#region Multi Site Variables

  //#endregion
  _showStockItemFileNotes: boolean = false;
  _stockItemNotesModel: StockItemSummary;
  //#region   CTOR
  constructor(private _inventoriesService: InventoriesService,
    private _accountsService: AccountsService,
    private _stockItemsService: StockItemsService,
    private _fb: FormBuilder,
    private _themeManager: ThemeManagerService,
    private _layoutManager: LayoutManagerService,
    private _layoutComponent: LayoutComponent,
    private _filesService: FilesService,
    private _vendorsService: VendorsService,
    private _categoriesService: CategoriesService,
    private _unitOfMeasuresService: UnitOfMeasuresService,
    private _customFieldsService: CustomFieldsService,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _barcodeGeneratorsService: BarcodeGeneratorsService,
    private _securityService: SecurityService,
    private _locationsService: LocationsService,
    private service: StockDataService,
    private _gridFields: GridFieldsService,
    private _sysReceivesService: SysReceivesService,
    public cdRef: ChangeDetectorRef,
    public _assembleSettingsService: AssembleSettingsService,
    private _formatService: FormatService,
    private _sharedService: SharedService,
    private quantityFormatsService: QuantityFormatsService,
    private _purchaseOrdersService: PurchaseOrdersService,
    private _receiveTransactionService: ReceiveTransactionsService,
    private _issueTransactionService: IssueTransactionsService,
    private _salesOrdersService: SalesOrdersService,
    private _userService: UsersService,
    private _dataService: GDataService,
    private _upcOnlineSettingsService: UPCOnlineSettingsService,
    private _multiSitesService: MultiSiteService) {
    super();
    this._currentUser = this._securityService.currentUser;
    this._isLiveEnterprise = environment.liveEnterprise;

    this.openfromlist = this._sharedService.model.openfromlist;
    this._datePickerFormat = this._formatService.dateFormat;
    this._costFormat = this._formatService.costFormatValue;
    this._getdata();
    this.LoadData();

    const loggedInAccountSites =
      localStorage.getItem('loggedInAccountSites') ?? '';

    if (loggedInAccountSites && loggedInAccountSites != '')
      this._loadLocationsDD(JSON.parse(loggedInAccountSites)[0].siteId);
    // else
    //   this._loadLocationsDD(this._selectedAccounts[0]?.siteId);

    this._upcOnlineSettingsService.getUPCOnlineSettings().subscribe((data) => {
      if (data != undefined && data != null)
        this.isUpcOnlineSetting = data.enabled;
    });

    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });
    this._layoutManager.formChanged.subscribe((x) => {
      if (x === 'vendors') {
        this._loadVendorsDD();
      }

      if (x === 'locations') {
        if (this._form.get('site').value) {
          const loggedInAccountSites =
            localStorage.getItem('loggedInAccountSites') ?? '';
          var siteId = JSON.parse(loggedInAccountSites)[0].siteId;
          this._loadLocationsDD(siteId);
        } else {
          setTimeout(() => {
            if (this.kendoComboVendors != undefined) {
              this.kendoComboVendors.toggle();
              this.kendoComboVendors.focus();
            }
          });
        }
      }



    });
    //#region category Subscription
    this._categoriesService.categoryAdded.subscribe(category => {
      if (this._currentUser.isEnterprise) {
        if (category.accountIds && category.accountIds.length > 0) {
          var allSelectedAccountsExistInCategory = true;
          this._selectedAccounts.forEach(element => {
            if (!category.accountIds.find((x: number) => x == element.accountId))
              allSelectedAccountsExistInCategory = false;
          });

          if (allSelectedAccountsExistInCategory) {
            if (!this._categories.find(x => x.id == category.id)) {
              this._categories.push(category);
              this._categoriesFiltered = this._categories;

              this._form.patchValue({ category: category });
            }
          }
        }
      }
      else {
        if (!this._categories.find(x => x.id == category.id)) {
          this._categories.push(category);
          this._categoriesFiltered = this._categories;

          this._form.patchValue({ category: category });
        }
      }
    });

    this._categoriesService.categoryUpdated.subscribe(category => {
      var UpdatedRecord = this._categories.find(x => x.id == category.id);
      if (UpdatedRecord) {
        var Index = this._categories.indexOf(UpdatedRecord);

        if (Index != -1) {
          this._categories[Index] = category;
          this._categoriesFiltered = this._categories;
          this._form.patchValue({ category: category });
        }
      }

    })
    //#endregion
    //#region uom Subscription
    this._unitOfMeasuresService.UOMAdded.subscribe(uom => {
      if (this._currentUser.isEnterprise) {
        if (uom.accountIds && uom.accountIds.length > 0) {
          var allSelectedAccountsExistInUOM = true;
          this._selectedAccounts.forEach(element => {
            if (!uom.accountIds.find((x: number) => x == element.accountId))
              allSelectedAccountsExistInUOM = false;
          });
          if (allSelectedAccountsExistInUOM) {
            if (!this._unitOfMeasures.find(x => x.id == uom.id)) {
              this._unitOfMeasures.push(uom);
              this._receiveUnitOfMeasuresFiltered = this._unitOfMeasures;
              this._inventoryUnitOfMeasuresFiltered = this._unitOfMeasures;
              this._issueUnitOfMeasuresFiltered = this._unitOfMeasures;

              if (this.selectedobjectname != null) {
                this._form.get(this.selectedobjectname).setValue(uom);
              }
            }
          }
        }
      }
      else {
        if (!this._unitOfMeasures.find(x => x.id == uom.id)) {
          this._unitOfMeasures.push(uom);
          this._receiveUnitOfMeasuresFiltered = this._unitOfMeasures;
          this._inventoryUnitOfMeasuresFiltered = this._unitOfMeasures;
          this._issueUnitOfMeasuresFiltered = this._unitOfMeasures;
        }
      }
    });

    this._unitOfMeasuresService.UOMUpdated.subscribe(uom => {
      var UpdatedRecord = this._unitOfMeasures.find(x => x.id == uom.id);

      if (UpdatedRecord) {
        var Index = this._unitOfMeasures.indexOf(UpdatedRecord);

        if (Index != -1) {
          this._unitOfMeasures[Index] = uom;
          this._receiveUnitOfMeasuresFiltered = this._unitOfMeasures;
          this._inventoryUnitOfMeasuresFiltered = this._unitOfMeasures;
          this._issueUnitOfMeasuresFiltered = this._unitOfMeasures;

          if (this.selectedobjectname != null) {
            this._form.get(this.selectedobjectname).setValue(uom);
          }
        }

      }
    });
    //#endregion
    //#region vendor Subscription
    this._vendorsService.vendorAdded.subscribe(vendor => {
      if (this._currentUser.isEnterprise) {
        if (vendor.accountSites && vendor.accountSites.length > 0) {
          var allSelectedAccountsExistInUOM = true;

          this._selectedAccounts.forEach(element => {
            if (!vendor.accountSites.find((x: any) => x.accountId == element.accountId))
              allSelectedAccountsExistInUOM = false;
          });

          if (allSelectedAccountsExistInUOM) {
            if (!this._stockItemVendor.find(x => x.vendorId == vendor.id)) {
              this.GetVendorById(vendor.id);
            }
          }
        }
      }
      else {
        this.GetVendorById(vendor.id);
      }
    });

    this._vendorsService.vendorUpdated.subscribe(vendor => {
      var UpdatedRecord = this._stockItemVendor.find(x => x.vendorId == vendor.id);

      if (UpdatedRecord) {
        var Index = this._stockItemVendor.indexOf(UpdatedRecord);

        if (Index != -1) {
          this._stockItemVendor[Index].code = vendor.code;
          this._stockItemVendor[Index].vendor.code = vendor.code;
          this._stockItemVendor[Index].vendor.name = vendor.name;
        }
      }
    });

    //#endregion
    this._layoutManager.applyOverly();
    if (this._pageState == PageState.EDIT || this._pageState == PageState.VIEW) {
      const selectedAccounts = [...this._selectedAccounts];
      (this._model.stockItemSites || []).forEach((item) => {
        const accountId = item.account?.id ?? (item as any).accountId;
        const siteId = item.site?.id ?? (item as any).siteId;
        if (accountId != null && accountId > 0 && !selectedAccounts.some((x) => x.accountId === accountId)) {
          selectedAccounts.push({
            siteId: siteId,
            accountId: accountId,
          });
        }
      });
      this._selectedAccounts = selectedAccounts;
      this._selectedAccountIds = selectedAccounts.map((x) => x.accountId);

      this._selectedImagesKeys = this._model.stockItemFiles.map((x: StockItemFile) => { if (x.file?.type?.includes('image')) return +x.fileid; });
      this._selectedDocumentsKeys = this._model.stockItemFiles.map((x: StockItemFile) => { if (x.file?.type?.includes('application')) return +x.fileid; });

      this._tabEnabled = this._selectedAccounts.length > 0;

      this._stockItemsService.getItemPerPOChart(this._model.id).subscribe((x) => {
        this.listPerPOChart = x as Array<any>;
        var dateStart = moment('2021-01-01');
        var dateEnd = moment('2021-12-30');
        var timeValues = [];
        var status1 = Array<any>();
        var status2 = Array<any>();
        var status3 = Array<any>();
        var status4 = Array<any>();
        var status5 = Array<any>();
        var status6 = Array<any>();
        while (dateEnd > dateStart || dateStart.format('M') === dateEnd.format('M')) {
          timeValues.push(dateStart.format('MMM yy'));
          status1.push(0);
          status2.push(0);
          status3.push(0);
          status4.push(0);
          status5.push(0);
          status6.push(0);

          this.listPerPOChart.forEach((element) => {
            if (element.key.createdOn == dateStart.format('MMM YY')) {
              if (element.key.orderStatus == 1) {
                status1.pop();
                status1.push(element.sum);
              }
              else if (element.key.orderStatus == 2) {
                status2.pop();
                status2.push(element.sum);
              }
              else if (element.key.orderStatus == 3) {
                status3.pop();
                status3.push(element.sum);
              }
              else if (element.key.orderStatus == 4) {
                status4.pop();
                status4.push(element.sum);
              }
              else if (element.key.orderStatus == 5) {
                status5.pop();
                status5.push(element.sum);
              }
              else if (element.key.orderStatus == 6) {
                status6.pop();
                status6.push(element.sum);
              }
            }
          });

          dateStart.add(1, 'month');
        }

        this.poMonths = timeValues;
        this.poStatus1 = status1;
        this.poStatus2 = status2;
        this.poStatus3 = status3;
        this.poStatus4 = status4;
        this.poStatus5 = status5;
        this.poStatus6 = status6;
      });

      this._stockItemsService.getItemPerSOChart(this._model.id).subscribe((x) => {
        this.listPerSOChart = x as Array<any>;
        var dateStart = moment('2021-01-01');
        var dateEnd = moment('2021-12-30');
        var timeValues = [];
        var status1 = Array<any>();
        var status2 = Array<any>();
        var status3 = Array<any>();
        var status4 = Array<any>();
        var status5 = Array<any>();
        var status6 = Array<any>();

        while (dateEnd > dateStart || dateStart.format('M') === dateEnd.format('M')) {
          timeValues.push(dateStart.format('MMM yy'));
          status1.push(0);
          status2.push(0);
          status3.push(0);
          status4.push(0);
          status5.push(0);
          status6.push(0);

          this.listPerSOChart.forEach((element) => {
            if (element.key.createdOn == dateStart.format('MMM YY')) {
              if (element.key.orderStatus == 1) {
                status1.pop();
                status1.push(element.sum);
              }
              else if (element.key.orderStatus == 2) {
                status2.pop();
                status2.push(element.sum);
              }
              else if (element.key.orderStatus == 3) {
                status3.pop();
                status3.push(element.sum);
              }
              else if (element.key.orderStatus == 4) {
                status4.pop();
                status4.push(element.sum);
              }
              else if (element.key.orderStatus == 5) {
                status5.pop();
                status5.push(element.sum);
              }
              else if (element.key.orderStatus == 6) {
                status6.pop();
                status6.push(element.sum);
              }
            }
          });

          dateStart.add(1, 'month');
        }

        this.soMonths = timeValues;
        this.soStatus1 = status1;
        this.soStatus2 = status2;
        this.soStatus3 = status3;
        this.soStatus4 = status4;
        this.soStatus5 = status5;
        this.soStatus6 = status6;
      });

      if (this._model.id) {
        this._stockItemsService.getItemQtyPerLocation(this._model.id).subscribe((x: any) => {
          this.listLocationQty = x;
        });

        this._stockItemsService.getQuantityPerDate(this._model.id).subscribe((x: any) => {
          this.listQtyPerDate = x;
        });

        this._stockItemsService.getStockHistory(this._model.id).subscribe((x: any) => {
          this.stockHistory = x;
        });

        this._stockItemsService.getMinMax(this._model.id).subscribe((x: any) => {
          this.listMinMax = x;
        });

        // this._stockItemsService
        //   .getImageDirectoryAndPrimaryImageStream(this._model.id)
        //   .subscribe((x: any) => {
        //     if (x != null) {
        //       this.urlAndStream = x.directory + '/' + x.stream;
        //     }
        //     // this.urlAndStream = "https://stagingapplianceapi.asapsystems.com/Resources/AccountId_1/images/semaan.jpeg";
        //   });
      }

      this._loadAlternateStocksGrid2();

      this._loadStatus();
    }

    this._customFieldsService.getDeactivatedCustomFields('stock', this._page).subscribe((data: Array<any>) => {
      this._deactivatedFieldsGridData = data.filter((x) => x.formTab.page === this._page);
    });

    this._LoadCategoriesDD();
    this._LoadUnitOfMeasuresDD();
    //this.loadCustomFields(this._model?.id?.toString());

    this._imageSearchControl.valueChanges.pipe(debounceTime(700), distinctUntilChanged()).subscribe((q) => {
      this._imageSearchResult = q;
      // setTimeout(() => {
      //   this.imageSearchInput.nativeElement.focus();
      // }, 500);
    });

    this._LocationSearchControl.valueChanges.pipe(debounceTime(700), distinctUntilChanged()).subscribe((q) => {
      this._LocationSearchResult = q;
      // setTimeout(() => {
      //   this.imageSearchInput.nativeElement.focus();
      // }, 500);
    });

    this._vendorSearchControl.valueChanges.pipe(debounceTime(700), distinctUntilChanged()).subscribe((q) => {
      this._vendorSearchResult = q;
      // setTimeout(() => {
      //   this.imageSearchInput.nativeElement.focus();
      // }, 500);
    });

    this._documentSearchControl.valueChanges.pipe(debounceTime(700), distinctUntilChanged()).subscribe((q) => {
      this._documentSearchResult = q;
      // setTimeout(() => {
      //   this.imageSearchInput.nativeElement.focus();
      // }, 500);
    });

    this._storagePath =
      EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/'; //environment.api.urls.enterpriseApi + '\\';

    if (window.navigator.userAgent.indexOf('Mac') != -1) {
      this._isOs = true;
    }

    this._currentUser = this._securityService.currentUser;

    service.getAll({ from: this.from, to: this.to }).then((data) => {
      this.navigatorData = data[0];
      this.seriesData = data[1];
    });

    this.loadLabels();

    if (!this._currentUser.isEnterprise) this.getSysReceiveSettings();

    this._locationsService.locationAdded.subscribe((x) => {
      let stockItemLocationMinMax: StockLocationMinMax = new StockLocationMinMax();

      stockItemLocationMinMax.locationId = x.id;
      stockItemLocationMinMax.location = x;

      this._stockItemLocationMinMax.push(stockItemLocationMinMax);
    });

    this._gridFields.getGridFieldsByPage('stockItems').subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects('stockItems', data);
    });

    this._gridFields.getGridFieldsByPage('locations').subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects('locations', data);
    });

    this._gridFields.getGridFieldsByPage('files').subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects('files', data);
    });

    this._gridFields.getGridFieldsByPage('documents').subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects('documents', data);
    });

    this._gridFields.getGridFieldsByPage('categories').subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects('categories', data);
    });

    this._gridFields.getGridFieldsByPage('uom').subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects('uom', data);
    });

    this._gridFields.getGridFieldsByPage('vendors').subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects('vendors', data);
    });

    this._gridFields.getGridFieldsByPage('stockItems').subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects('stockItems', data);
    });

    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('locations', (gridColumns) => {
      this._locationsGridColumns = gridColumns;
    }));

    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('files', (gridColumns) => {
      this._picturesGridColumns = gridColumns;
    }));

    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('documents', (gridColumns) => {
      this._documentsGridColumns = gridColumns;
    }));

    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('videos', (gridColumns) => {
      this._videosGridColumns = gridColumns;
    }));

    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('vendors', (gridColumns) => {
      this._vendorGridColumns = gridColumns;
    }));

    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('categories', (gridColumns) => {
      this._categoryGridColumns = gridColumns;
    }));

    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('uom', (gridColumns) => {
      this._uomGridColumns = gridColumns;
    }));

    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('stockItems', (gridColumns) => {
      this._stockItemsGridColumns = gridColumns;
    }));
  }

  //#endregion
  //#region  LoadData
  async LoadData() {
    this.quantityFormat = await this.quantityFormatsService.getQuantityFormatForNumericTextBox();

    this.digitNumber = await this.quantityFormatsService.getDigitNumber(this.quantityFormat);
  }

  //#endregion
  _getUnitOfMeasures = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    if (this._currentUser.isEnterprise) {
      model.accountIds = this._selectedAccountIds;
    }

    return this._unitOfMeasuresService.getUnitOfMeasures(params, model);
  };
  //#region LoadQuantityPerLocation
  async LoadQuantityPerLocation() {
    this._stockItemsService.getQuantityPerLocationChart(this._model.id).pipe().subscribe((data: any) => {
      this.quantityPerLocationChartDetail = data;
      if (data && data.chart) {
        this.quantityPerLocationChart = data.chart;
        this.quantityPerLocationChart.xaxis = data.chart.xaxis;

        var xaxis: any = {
          type: 'category',
          labels: {
            formatter: (val: any) => this.GetXaxisValues(val),
          }
        };

        if (this.quantityPerLocationChart.xaxis) {
          this.quantityPerLocationChart.xaxis.labels = xaxis.labels;
        }
      }
    });
  }
  //#endregion

  //#region  GetXaxisValues
  GetXaxisValues(val: any) {
    return val;
  }
  //#endregion

  //#region  LoadStockItemQuantityMinMax
  async LoadStockItemQuantityMinMax() {
    this._stockItemsService.getStockItemQuantityMinMaxChart(this._model.id).pipe().subscribe(async (data: any) => {
      this.stockItemQuantityMinMaxChartDetail = data;
      this.stockItemQuantityMinMaxChart = data.chart;
    });

    this._gridFields.getGridFieldsByPage('inventories').subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects('inventories', data);
      this._inventoriesColumns = data;
    });
  }
  //#endregion

  //#region LoadPoSoChart
  async LoadPoSoChart() {
    this._stockItemsService.getSoPoStockItemChart(this._model.id).pipe().subscribe(async (data: any) => {
      this.poSoChartDetail = data;
      this.poSoChart = data.chart;
    });

    this._gridFields.getGridFieldsByPage('purchaseOrders').subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects('purchaseOrders', data);
      this._poGridColumns = data;
    });

    this._gridFields.getGridFieldsByPage('salesOrders').subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects('salesOrders', data);
      this._soGridColumns = data;
    });
  }
  //#endregion

  //#region LoadStockHistoryChart
  async LoadStockHistoryChart() {
    this._stockItemsService.getStockHistoryChart(this._model.id).pipe().subscribe(async (data: any) => {
      this.stockItemHistoryDetail = data;
      this.stockItemHistoryChart = data.chart;
    });

    this._gridFields.getGridFieldsByPage('receiveHistory').subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects('receiveHistory', data);
      this._receiveGridColumns = data;
    });

    this._gridFields.getGridFieldsByPage('issueHistory').subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects('issueHistory', data);
      this._issueGridColumns = data;
    });
  }

  //#endregion
  _getPurchaseOrders = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    var startEndDate: any = {
      startDate: this.poSoChartDetail.startDate,
      endDate: this.poSoChartDetail.endDate,
      purchaseOrdderModel: model
    };

    return this._purchaseOrdersService.GetPurchaseOrderByStockItem(
      this._model.id,
      startEndDate,
      params
    );
  };

  getMarkupType(obj: any, propString: any) {
    if (obj.costInfo.isCalculatedPrice) return 'Calclulated Price';
    else if (obj.costInfo.isFixedPrice) return 'Fixed Price';
  }

  displayCatImage(input: string, ListOfItems: any = null) {
    let primaryPicture;
    if (ListOfItems != null) {
      primaryPicture = ListOfItems.find(
        (v: any) => v.categoryFilePrimary == true
      );
      if (primaryPicture != undefined && primaryPicture != null)
        input = primaryPicture.file.thumbnail;
    }

    return EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/' + input;
  }

  _getSalesOrders = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    var startEndDate: any = {
      startDate: this.poSoChartDetail.startDate,
      endDate: this.poSoChartDetail.endDate,
      salesOrdderModel: model
    };

    return this._salesOrdersService.GetSalesOrderByStockItem(
      this._model.id,
      startEndDate,
      params
    );
  };

  getDispacthType(obj: any, propString: any) {
    if (!obj.isPickUp) {
      return "Ship"
    }
    else {
      return "Pick-Up"
    }
  }

  _getInventoryStockItemId = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    var startEndDate: any = {
      startDate: this.stockItemQuantityMinMaxChartDetail.startDate,
      endDate: this.stockItemQuantityMinMaxChartDetail.endDate,
    };

    return this._inventoriesService.getInventoryByStockItem(this._model.id, startEndDate);
  };

  _getReceiveTransactions = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    var startEndDate: any = {
      startDate: this.stockItemHistoryDetail.startDate,
      endDate: this.stockItemHistoryDetail.endDate,
    };

    return this._receiveTransactionService.GetReceiveTransactionByStockItem(this._model.id, startEndDate);
  };

  _getIssueTransactions = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    var startEndDate: any = {
      startDate: this.stockItemHistoryDetail.startDate,
      endDate: this.stockItemHistoryDetail.endDate,
    };

    return this._issueTransactionService.GetIssueTransactionByStockItem(this._model.id, startEndDate);
  };

  ExpandCollapsePoSoGrid(isExpand: boolean) {
    this.isPoSoGridExpanded = !isExpand;
  }

  ExpandCollapsePoSoChart(isExpand: boolean) {
    this.isPoSoChartExpanded = !isExpand;
  }

  ExpandCollapseInventoriesGrid(isExpand: boolean) {
    this.isInventoryGridExpanded = !isExpand;
  }

  ExpandCollapseInventoriesChart(isExpand: boolean) {
    this.isInventoryChartExpanded = !isExpand;
  }

  ExpandCollapseStockHistoryGrid(isExpand: boolean) {
    this.isStockHistoryGridExpanded = !isExpand;
  }

  ExpandCollapseStockHistoryChart(isExpand: boolean) {
    this.isStockHistoryChartExpanded = !isExpand;
  }

  _getdata() {
    this._model = this._sharedService.model && this._sharedService.model.model ? this._sharedService.model.model : null;
    this._pageState = this._sharedService.model && this._sharedService.model.pageState ? this._sharedService.model.pageState : null;
    this._active = true;

    if (this._model?.stockItemFiles) {
      this._model.stockItemFiles.forEach((element: StockItemFile) => {
        if (element.file?.type.includes('image')) {
          this._stockItemFilesPics.push(element);
        }
        else if (element.file?.type.includes('video')) {
          this._stockItemFilesVideo.push(element);
        }
        else if (element.file?.type.includes('application')) {
          this._stockItemFilesDoc.push(element);
        }
      });
    }

    this._stockItemVendor = this._model?.stockItemVendors ? this._model.stockItemVendors : [];

    if (this._model?.stockLocationsMinMax) {
      this._model.stockLocationsMinMax.forEach(
        (element: StockLocationMinMax) => {
          let stockItemLocationMinMax: StockLocationMinMax =
            new StockLocationMinMax();
          // stockItemLocationMinMax.location.code = element.code;
          stockItemLocationMinMax = element;
          this._stockItemLocationMinMax.push(stockItemLocationMinMax);
        });
    }

    // this._stockItemLocationMinMax = this._model?.stockLocationsMinMax ? this._model.stockLocationsMinMax : [];
    if (this._pageState === PageState.COPY) {
      this.isCopySelection = true;
      this._model.number = null;
    }

    if ((this._pageState === PageState.ADD || this._pageState === PageState.COPY) && this._model) {
      this.copyModelId = this._model.id;
      this._model.id = null;
    }

    if (this._pageState === PageState.COPY && this._model) {
      this._model.costInfo.id = 0;
    }

    if (this._model && this._model.id) {
      this.LoadPoSoChart();
      this.LoadQuantityPerLocation();
      this.LoadStockHistoryChart();
      this.LoadStockItemQuantityMinMax();

      //this._loadVendorsDropDown();
    }

    this.IsTaxable = this._model?.costInfo?.isTaxable;

    this.isReceived = this.isCopySelection ? false : this._model?.isReceived;

    if (!this._currentUser.isEnterprise) {
      if (this._model && this._model.site) {
        this._loadFormSites(true, this._model.site);
      }
      else {
        this._loadFormSites();
      }
    }
  }
  GetStockItemForBill(siteId?: number) {
    return this._stockItemsService.getStockItemsForBill(siteId).pipe().subscribe((x: any) => {
      this._stockItemData = x.body;
      this._stockItemSearchList = x.body;
      this._stockItemsSubstitutes = x.body;
    });
  }

  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }

  //#region
  ngOnInit() {
    this.setSelectableSettings()
    this._viewInactiveFormTabs(true);
    /** Format */
    this._datePickerFormat = this._formatService.dateFormat;
    this._costFormat = this._formatService.costFormatValue;
    this._getUsers();
    this._LoadItemTypesDD();
    this._LoadCostTypesDD();
    //this._getStockItems();

    this._locationsService.getLocationListing().subscribe((data: any) => {
      var locations = data;

      if (this._model?.iskit) {
        if (this._model.stockItemKitDetails) {
          this._model.stockItemKitDetails.forEach((item: any) => {
            this._selectedKitStockItem = item.stockItem
            this._selecttedKitQuantity = item.quantity;
            this._selectedKitDefaultLocation = data.find((x: any) => x.id == item.defaultLocationId);
            this.addNewBillOfMatrials();
          });

          if (this._model.stockItemSubKitList) {
            this._model.stockItemSubKitList.forEach((item: any) => {
              this._selectedKitStockItem = item.subDetailStockItem;
              this._selectedKitStockItemDetail = item.stockItemKitDetail.stockItem;

              this._selecttedKitDetailQuantity = item.quantity;
              this._selectedKitDetailDefaultLocation = data.find((x: any) => x.id == item.defaultLocationId);
              this.addNewBillOfMatrialsDetail();
            });
          }
        }
      }
    });

    if (!this._currentUser.isEnterprise) {
      this.getLicense();

      const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? '';

      if (loggedInAccountSites != '') {
        var accountId = JSON.parse(loggedInAccountSites)[0].accountId;
        var siteId = JSON.parse(loggedInAccountSites)[0].siteId;
        this._loggedInAccountId = accountId;
        this._loggedInSiteId = siteId;
        this._selectedAccounts.push({ siteId: siteId, accountId: accountId });
        this._loadLocationsDD(siteId);
      }

      this._tabEnabled = this._selectedAccounts.length > 0;
      //Quraim
      this._dataService.dataTransferObservable.subscribe((str) => {
        if (str.isAttachment == true) {
          if (str?.response && str.component == 'files') {
            this._addStockPic(str);
            /*if(str.id)
              this.GetImageById(str.id);
            else
              this.GetImageById(str.response); */
            //this._isDialiog = false;
          }
          if (str?.response && str.component == 'documents') {
            this._addStockDoc(str);
            /* if(str.id)
              this.GetDocById(str.id);
            else
              this.GetDocById(str.response);
              this._isDialiog = false; */
          }
          if (str?.response && str.component == 'videos') {
            this._addStockVideo(str);
          }
        }
      });
    }

    this._initForm();
    if (this.isReceived) {
      this._form.get('costtype')?.disable()
      this._form.get('itemtype')?.disable()
      this._form.get('inventoryunitofmeasure')?.disable()
      this._form.get('receiveunitofmeasure')?.disable()
      this._form.get('issueunitofmeasure')?.disable()

    }

    // this._disabledViewMode();
    let windowSize = window.innerWidth;

    if (windowSize <= 991) {
      this._kendoTabStripPosition = 'top';
    }
    else {
      this._kendoTabStripPosition = 'left';
    }

    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        this.kendoBarcodeGenStockNumber.nativeElement.focus();
      }, 500);
    }

    this._sitemNumber.valueChanges.subscribe((x) => {
      if (x) {
        this._form.patchValue({
          number: x.toString(),
        });
      }
    });

    this._form.get('receiveunitofmeasure').valueChanges.subscribe((x) => {
      if (x) {
        if (!this._form.get('inventoryunitofmeasure').value) {
          // setTimeout(() => {
          //   this.KendoComboboxInventoryUM.toggle(true);
          //   this.KendoComboboxInventoryUM.focus();
          // });
        }
      }
    });
    this._form.get('inventoryunitofmeasure').valueChanges.subscribe((x) => {
      if (x) {
        if (!this._form.get('issueunitofmeasure').value) {
          // setTimeout(() => {
          //   this.KendoComboboxIssueUM.toggle(true);
          //   this.KendoComboboxIssueUM.focus();
          // });
        }
      }
    });
    this.sortProduct((p) => p.order, 'ASC');
    if (!this._currentUser.isEnterprise) {
      this._tabEnabled = true;
    }
    if (this._selectedImagesKeys.length === 0) {
      this._showimageTab = false;
    } else {
      this._showimageTab = true;
    }

    this.getFormTabs();
    //this.getSystemFields();
    this.getSystemFieldsAndCustomFields();
    this.getAuth();
    this.getLocationAuth();

    //this.getSiteMinMax();
  }
  //#endregion

  _viewInactiveFields() {
    this._customFieldsService
      .getDeactivatedCustomFields('stock', this._page)

      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(
          (x) => x.formTab.page === this._page
        );
      });
    // this._deactivatedFieldsForm = true;
  }
  _closeInactiveFields() {
    this._deactivatedFieldsForm = false;
  }

  _reactivate(item: any) {
    this.reactivateItem = item;
    this.reactivate = true;
    const sub = this._sharedService.okCloseClicked.subscribe((data: boolean) => {
      if (data && this.reactivate) {
        this.reactivate = false;
        this._customFieldsService
          .reactivateCustomField(this.reactivateItem.id, item)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true,
              });
              this.getFormTabs();
              if (response['close'] != null) {
                if (response['close'] == true) {
                  //this.loadCustomFields(this._model?.id?.toString());
                  this.getSystemFieldsAndCustomFields();
                  // this._deactivatedFieldsForm = false;
                } else {
                  return;
                }
              }
            }
            // this._deactivatedFieldsForm = false;
          });
        // this._deactivatedFieldsForm = false;
      } else {
        this.reactivate = false;
      }
      sub.unsubscribe();
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name,
    });
    // this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
  }

  _disableTabs() {
    this.GeneralTab.selected = false;
    this.costingTab.selected = false;
    this.stockInfoTab.selected = false;
    this.alternateStockItemTab.selected = false;
    this.picturesTab.selected = false;
    this.vendorsTab.selected = false;
  }

  _reorderingtabs() {
    this._orderingTabsForm = true;
  }
  openBillWindow() {
    this._showBillWindow = true;
  }
  openBillDetailWindow(event: any) {

    this._showBillDetailWindow = true;
    this._selectedKitStockItemDetail = this._stockItemsSubstitutes.find(
      (x: any) => x.number == event.stockCode
    );
    let selecctedKitIds = this._selectedListKit.map((x: any) => x.id);

    this._filterdStockItemData = this._stockItemData.filter((x: any) => x.id != event.id
      && !selecctedKitIds.includes(x.id));

    this._stockItemSearchList = this._stockItemSearchList.filter((x: any) => !selecctedKitIds.includes(x.id));

  }
  deleteBill(event: any, index: number) {

    this._selectedListKit.splice(index, 1);
    this._selectedListkitDetail = this._selectedListkitDetail.filter((x: any) => x.primaryStockId != event.id);
    this._selectedShowList = this._selectedListkitDetail.filter((x: any) => x.primaryStockId != event.id);
  }
  deleteBillDetail(event: any, index: number) {
    this._selectedListkitDetail.splice(index, 1);
    this._selectedShowList.splice(index, 1);
  }

  _selectStocksHandler(): void {
    this._showStocksGrid = true;
  }
  _onStockRowSelectionChanges(e: any[]) {
    this._selectedStocks = [];
    e.forEach((item) => {
      this._selectedStocks.push(item);
    });
  }
  // _returnSelectedStocksHandler(e: any[]): void {

  //   this._showStocksGrid = false;
  //   this._selectedStocks.forEach((item: StockItemSummary) => {

  //               this._inventoryGridData.push({
  //                       id:item.id,
  //                       backorderQty:0,
  //                       unitsIssued: 0,
  //                      stockItemId: item.id,
  //                       itemNumber: item.number,
  //                       description: item.description,
  //                       unitsOrdered: this._defaultQuantity.value ? (this._quantity.value ? +this._quantity.value : 0) : 0,
  //                      // uom: item.receiveUnitOfMeasure.code,
  //                      uom: item.issueUnitOfMeasure.code,
  //                       unitPrice: this.CalculateUnitPrice(item),
  //                       extendedPrice: this.CalculateUnitPrice(item) * (this._defaultQuantity.value ? (this._quantity.value ? +this._quantity.value : 0) : 0),
  //                       // unitPrice: this._defaultUnitPrice.value ? ((item.costInfo && item.costInfo.cost) ? item.costInfo.cost : 0) : (this._unitPrice.value ?? 0),
  //                       // extendedPrice: (this._defaultUnitPrice.value ? ((item.costInfo && item.costInfo.cost) ? item.costInfo.cost : 0) : (this._unitPrice.value ?? 0)) * (this._defaultQuantity.value ? (this._quantity.value ? +this._quantity.value : 0) : 0),
  //                       isTaxable: (item.costInfo != null && item.costInfo.isTaxable != null) ? item.costInfo.isTaxable : false,
  //               });

  //           })

  // }

  closeBillWindow() {
    this._showBillWindow = false;
    this._stockItemData = this._stockItemSearchList;
    this._selectedKitStockItem = null;
  }
  closeBillDetailWindow() {
    this._showBillDetailWindow = false;
    this._stockItemData = this._stockItemSearchList;
    this._selectedKitStockItem = null;
    this._selectedKitStockItemDetail = null;
  }


  addNewBillOfMatrials() {
    if (!this._selecttedKitQuantity || this._selecttedKitQuantity == 0) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Quantity Field Must be greater than 0',
        withoutConfirm: true,
      });
      return false;
    }
    if (!this._selectedKitStockItem) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please Fill Stock Item # Field ',
        withoutConfirm: true,
      });
      return false;
    }

    var stockExists = this._selectedListKit.find(
      (x: any) => x.id == this._selectedKitStockItem.id
    );

    if (!stockExists) {
      let stock = this._selectedKitStockItem;
      this._selectedKit.id = this._selectedKitStockItem.id;
      this._selectedKit.stockCode = this._selectedKitStockItem.number;
      this._selectedKit.stockDescription =
        this._selectedKitStockItem.description;
      this._selectedKit.stockUOM =
        this._selectedKitStockItem.receiveUnitOfMeasure?.code;
      this._selectedKit.cost = this._selectedKitStockItem?.costInfo?.cost ?? 0;

      this._selectedKit.quantity = this._selecttedKitQuantity;

      this._selectedKit.extendedCost = this._selectedKit.cost * this._selectedKit.quantity;

      this._selectedKit.defaultLocationCode =
        this._selectedKitDefaultLocation?.code;


      this._selectedKit.defaultLocationId =
        this._selectedKitDefaultLocation?.id;

      this._selectedListKit.push(this._selectedKit);
      this._selectedKit = {};
      this._selectedKitStockItem = null;
      this._selecttedKitQuantity = 0;
      this._selectedKitDefaultLocation = null;
      this._showBillWindow = false;
      this._stockItemData = this._stockItemSearchList;
    } else {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Stock Number already exists.',
        withoutConfirm: true,
      });
      return false;
    }
  }

  handleItemsChange(searchData: any) {
    this._stockItemData = this._stockItemSearchList.filter((x: any) => x.number.toLowerCase()
      .includes(searchData.toLowerCase()));
  }
  handleItemsDetailChange(searchData: any) {
    this._filterdStockItemData = this._stockItemSearchList.filter((x: any) => x.number.toLowerCase()
      .includes(searchData.toLowerCase()) && x.id != this._selectedKitStockItemDetail.id);
  }
  addNewBillOfMatrialsDetail() {
    //let stock=this._selectedKitStockItemDetail;

    if (
      !this._selecttedKitDetailQuantity ||
      this._selecttedKitDetailQuantity == 0
    ) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Quantity Field Must be greater than 0',
        withoutConfirm: true,
      });
      return false;
    }
    if (!this._selectedKitStockItem) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please Fill Stock Item # Field ',
        withoutConfirm: true,
      });
      return false;
    }


    this._selectedKit.primaryStockCode =
      this._selectedKitStockItemDetail.number;
    this._selectedKit.primaryStockDescription =
      this._selectedKitStockItemDetail.description;
    this._selectedKit.primaryStockId = this._selectedKitStockItemDetail.id;

    this._selectedKit.stockUOM =
      this._selectedKitStockItem.receiveUnitOfMeasure?.code;
    this._selectedKit.cost = this._selectedKitStockItem?.costInfo?.cost ?? 0;
    this._selectedKit.stockCode = this._selectedKitStockItem.number;
    this._selectedKit.stockDescription = this._selectedKitStockItem.description;
    this._selectedKit.stockId = this._selectedKitStockItem.id;

    this._selectedKit.quantity = this._selecttedKitDetailQuantity;

    this._selectedKit.extendedCost
      = this._selectedKit.quantity * this._selectedKit.cost

    this._selectedKit.defaultLocationCode =
      this._selectedKitDetailDefaultLocation?.code;
    this._selectedKit.defaultLocationId =
      this._selectedKitDetailDefaultLocation?.code.id;

    var isItemExists = this._selectedListkitDetail.find((x: any) => x.stockId == this._selectedKit.stockId &&
      x.primaryStockId == this._selectedKit.primaryStockId);
    if (!isItemExists) {
      this._selectedListkitDetail.push(this._selectedKit);
      this._selectedKitSubList.push(this._selectedKit);
      this._selectedShowList.push(this._selectedKit);

    }
    else {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Cannot Add The Same Substitute Twice For The Same Item',
        withoutConfirm: true,
      });
    }
    this._selectedKit = {};
    //this._selectedKitStockItemDetail = null;
    this._selectedKitStockItem = null;
    this._selecttedKitDetailQuantity = 0;
    this._selectedKitDetailDefaultLocation = null;
    this._showBillDetailWindow = false;
    this._allowSubstituteStock = true;
    this._stockItemData = this._stockItemSearchList;
    this._filterdStockItemData = this._stockItemSearchList;
  }

  _closeOrderingTabsForm() {
    this._orderingTabsForm = false;
    this._dataTabsSelected = this._userNewDataTabs;
  }
  sortProduct<T>(prop: (c: any) => T, order: 'ASC' | 'DESC'): void {
    this._dataTabs.sort((a, b) => {
      if (prop(a) < prop(b)) return -1;
      if (prop(a) > prop(b)) return 1;
      return 0;
    });

    if (order === 'DESC') {
      this._dataTabs.reverse();
      // this.productSortOrder = true;
    } else {
      // this.productSortOrder = false;
    }
  }

  _comboValueChange(e: any, i: number) {
    if (this._dataTabsSelected.find((x) => x.order == i + 1)) {
      this._userNewDataTabs.find(
        (x) => x === this._dataTabsSelected.find((x) => x.order == i + 1)
      ).order = this._dataTabsSelected.find((x) => x.name === e.name).order;
    }

    this._userNewDataTabs.find((obj) => obj.name == e.name).order = i + 1;
    this._dataTabsSelected = this._dataTabsSelected.filter((obj) => obj !== e);
  }

  _onSaveTabOrdering() {
    this._gridFields.updateFormTabsReorder(this._userNewDataTabs).subscribe((x: any) => {
      this._dataTabs = x;
      this._closeOrderingTabsForm();
    });
  }

  public onNavigatorFilter(e: any) {
    this.service.get({ from: e.from, to: e.to }).then((data) => {
      e.sender.skipNavigatorRedraw();
      // this.seriesData = data;
    });
  }

  _POSTabClick() {
    this._POSTabActive = true;
    this._SOSTabActive = false;
    this._MMQTabActive = false;
    this._imageTabActive = false;
    this._LSActive = false;
    this._SQActive = false;
    this._StockHistoryActive = false;
  }

  _SOSTabClick() {
    this._SOSTabActive = true;
    this._POSTabActive = false;
    this._MMQTabActive = false;
    this._imageTabActive = false;
    this._LSActive = false;
    this._SQActive = false;
    this._StockHistoryActive = false;
  }

  _MMQTabClick() {
    this._MMQTabActive = true;
    this._SOSTabActive = false;
    this._POSTabActive = false;
    this._imageTabActive = false;
    this._LSActive = false;
    this._SQActive = false;
    this._StockHistoryActive = false;
  }

  _imageTabClick() {
    this._imageTabActive = true;
    this._MMQTabActive = false;
    this._SOSTabActive = false;
    this._POSTabActive = false;
    this._LSActive = false;
    this._SQActive = false;
    this._StockHistoryActive = false;
  }

  _LSTabClick() {
    this._LSActive = true;
    this._imageTabActive = false;
    this._MMQTabActive = false;
    this._SOSTabActive = false;
    this._POSTabActive = false;
    this._SQActive = false;
    this._StockHistoryActive = false;
  }

  displayStockImage(input: string, ListOfItems: any = null) {
    let primaryPicture;
    if (ListOfItems != null) {
      primaryPicture = ListOfItems.find((v: any) => v.stockitemfileisprimary == true);

      if (primaryPicture != undefined && primaryPicture != null)
        input = primaryPicture.file.thumbnail;
    }

    return EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/' + input;
  }

  _closeStocksWindow(): void {
    this._showStocksGrid = false;
  }

  _returnSelectedStocksHandler(e: any[]): void {
    this._selectedKitStockItem = this._selectedStocks[0];
    this._showStocksGrid = false;
  }

  _SQTabClick() {
    this._SQActive = true;
    this._LSActive = false;
    this._imageTabActive = false;
    this._MMQTabActive = false;
    this._SOSTabActive = false;
    this._POSTabActive = false;
    this._StockHistoryActive = false;
  }

  _getStockItems = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {

    return this._stockItemsService.getStockItems(params, model, this._siteSelected?.id);
  };

  _StockHistoryTabClick() {
    this._StockHistoryActive = true;
    this._SQActive = false;
    this._LSActive = false;
    this._imageTabActive = false;
    this._MMQTabActive = false;
    this._SOSTabActive = false;
    this._POSTabActive = false;
  }

  _POSShartClick(event: any) {
    if ((event.target as HTMLElement).tagName != 'DIV')
      this._POSShartForm = true;
  }

  _closePOSShartForm() {
    this._POSShartForm = false;
  }

  _SOSShartClick() {
    this._SOSShartForm = true;
  }

  _closeSOSShartForm() {
    this._SOSShartForm = false;
  }

  _MMQShartClick() {
    this._MMQShartForm = true;
  }

  _closeMMQShartForm() {
    this._MMQShartForm = false;
  }

  _LSChartClick(event: any) {
    if ((event.target as HTMLElement).tagName != 'DIV')
      this._LSChartForm = true;
  }

  _closeLSChartForm() {
    this._LSChartForm = false;
  }

  _SQChartClick(event: any) {
    if ((event.target as HTMLElement).tagName != 'DIV')
      this._SQChartForm = true;
  }

  _closeSQChartForm() {
    this._SQChartForm = false;
  }

  _StockHistoryChartClick(event: any) {
    if ((event.target as HTMLElement).tagName != 'DIV')
      this._StockHistoryChartForm = true;
  }

  _CloseStockHistoryChartForm() {
    this._StockHistoryChartForm = false;
  }

  isChecked(item: any) {
    if (this._selectedItemStatus.find((x) => x.id === item.id)) {
      return true;
    }
    return false;
  }

  statusChecked(item: any) {
    let regularIndex = item.id == 'regular';
    let assembleIndex = item.id == 'assemble';
    let shoppingcartIndex = item.id == 'shoppingcart';

    if (regularIndex) {
      if (this._selectedItemStatus.length === 0) {
        this._selectedItemStatus.push({
          id: 'regular',
          title: 'Regular',
        });
      }
      else {
        this._selectedItemStatus = this._selectedItemStatus.filter((obj) => obj.id !== 'assemble');
        this._selectedItemStatus = this._selectedItemStatus.filter((obj) => obj.id !== 'shoppingcart');
      }
    }

    if (assembleIndex || shoppingcartIndex) {
      this._selectedItemStatus = this._selectedItemStatus.filter((obj) => obj.id !== 'regular');
    }
    // if (!assembleIndex && !shoppingcartIndex && !regularIndex) {
    //   this._selectedItemStatus = this._selectedItemStatus.filter(obj => obj.id === 'regular');
    // }
  }

  _isItemStatusSelectedevent(e: any) {
    let regularIndex = e.findIndex((x: { id: string }) => x.id === 'regular');
    if (regularIndex === -1 && this._selectedItemStatus.length === 0) {
      this._selectedItemStatus.push({ id: 'regular', title: 'Regular' });
    }

    if (this._selectedItemStatus.length > 1 && regularIndex > -1) {
      this._selectedItemStatus = this._selectedItemStatus.filter((obj) => obj.id !== 'assemble');
      this._selectedItemStatus = this._selectedItemStatus.filter((obj) => obj.id !== 'shoppingcart');
    }
    else if (this._selectedItemStatus.length > 1 && regularIndex === -1) {
      this._selectedItemStatus = this._selectedItemStatus.filter((obj) => obj.id !== 'regular');
    }

    this._isKit = this._selectedItemStatus ? this._selectedItemStatus.filter((obj) => obj.id === 'assemble').length > 0 : false;
  }

  isRegularIncluded = false;

  _isItemStatusCostingSelectedevent(e: any) {
    if (e.id == 'fixedprice') {
      this._form.controls.pricemarkuppercent.setValue(null);
      this._form.controls.pricemarkupnumber.setValue(null);

      this._form.controls.pricemarkuppercent.disable();
      this._form.controls.pricemarkupnumber.disable();

      this._form.controls.fixedunitprice.enable();
    }
    else if (e.id == 'calculateprice') {
      this._form.controls.fixedunitprice.setValue(null);
      this._form.controls.pricemarkuppercent.enable();
      this._form.controls.pricemarkupnumber.enable();
      this._form.controls.fixedunitprice.disable();
    }

    this._currentStatusCostingvalue = e;
    this._form.get('fixedprice').setValue(e.id === 'fixedprice' ? true : false);
    this._form.get('calprice').setValue(e.id === 'calculateprice' ? true : false);
  }

  priceMarkupPercentChange(value: any) {
    if (value != null) this._form.controls.pricemarkupnumber.disable();
    else this._form.controls.pricemarkupnumber.enable();
  }

  priceMarkupNumberChange(value: any) {
    if (value != null) this._form.controls.pricemarkuppercent.disable();
    else this._form.controls.pricemarkuppercent.enable();
  }

  _isItemStatusCostingSelected(id: any) {
    return this._currentStatusCostingvalue ? this._currentStatusCostingvalue.some((item) => item.id === id) : false;
  }

  _openCirclesForm() {
    this._showCirclesForm = true;
    this._tooltipVisibilityUpsert = false;
  }

  _closeCirclesForm() {
    this._showCirclesForm = false;
    this._tooltipVisibilityUpsert = true;
  }

  getSelectedAccountIds(): number[] {
    return (this._selectedAccounts || [])
      .map((x) => (typeof x === 'number' ? x : (x?.accountId ?? x?.id)))
      .filter((x) => x != null && !isNaN(x) && x > 0);
  }

  _getAccounts = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._accountsService.getAccounts(params, model);
  };

  _getAccountImages = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._filesService.getAccountsPictures(
      this.getSelectedAccountIds(),
      params,
      model
    );
  };

  _getAccountVendors = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._vendorsService.getAccountsVendors(
      this.getSelectedAccountIds(),
      params,
      model
    );
  };

  _getSiteLocation = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._locationsService.getAccountLocation(
      this.getSelectedAccountIds(),
      params,
      model
    );
  };

  assemblyChange() {
    if (!this._isKit) {
      this.tabstrip.selectTab(0);
    }
    else {
      this.kittingTab.selected = true;
      this._disableTabs();
    }
  }

  shoppingChange() {
    if (!this._isShopping) {
      this._shoppingUM = "";
    }
  }

  _getSelectedImages = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._filesService.getPictures(params, model);
  };

  _getSelectedDocuments = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    model['accountIds'] = this.getSelectedAccountIds();
    return this._filesService.getDocuments(
      params, model);
  };

  _getSelectedVendors = (
    params?: any,
    model?: any
  ): Observable<DataWithPagingMetadata<any>> => {
    return this._vendorsService.getVendors(params, model);
  };

  _handleCategoryFilter(value: any) {
    this._categoriesFiltered = this._categories.filter((s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  setFileSize(e: number) {
    return Math.round(e / 1000);
  }

  _handleReceiveUnitOfMeasuresFilter(value: any) {
    this._receiveUnitOfMeasuresFiltered = this._unitOfMeasures.filter(
      (s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  _handleDefaultLocationFilter(value: any) {
    this._locationsFiltered = this._locationsFiltered.filter(
      (s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }
  _handleInventoryUnitOfMeasuresFilter(value: any) {
    this._inventoryUnitOfMeasuresFiltered = this._unitOfMeasures.filter(
      (s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  _handleIssueUnitOfMeasuresFilter(value: any) {
    this._issueUnitOfMeasuresFiltered = this._unitOfMeasures.filter(
      (s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  // _disabledViewMode() {
  //   if(this._pageState == PageState.VIEW){
  //     this.accountTab.selectTab;
  //   }
  // }

  _barcodeSubmited() {
    this._sitemNumber.setValue(this._form.get('number').value);
    if (this._sitemNumber.value != null) {
      // setTimeout(() => {
      //   this.kendoComboboxItemType.toggle(true);
      //   this.kendoComboboxItemType.focus();
      // });
      if (this._pageState == PageState.ADD) {
        setTimeout(() => {
          this.kendoStockDescriptionInput.nativeElement.focus();
          let StockDesc = this.kendoStockDescriptionInput;
          StockDesc.nativeElement.classList.add('focusedInput');
        });
      }
    }
  }

  _LoadCategoriesDD() {
    return this._categoriesService.getAccountCategories(this.getSelectedAccountIds()).subscribe((data: any) => {
      this._categories = data;
      this._categoriesFiltered = this._categories;
    });
  }

  _LoadUnitOfMeasuresDD() {
    return this._unitOfMeasuresService
      .getAccountUnitOfMeasures(this.getSelectedAccountIds())
      .subscribe((data: any) => {
        this._unitOfMeasures = data;
        this._receiveUnitOfMeasuresFiltered = this._unitOfMeasures;
        this._inventoryUnitOfMeasuresFiltered = this._unitOfMeasures;
        this._issueUnitOfMeasuresFiltered = this._unitOfMeasures;

        if (!this._model?.id && this.reloaduom <= 0) {
          const defaultUOM = this._unitOfMeasures?.find((x) => x.code == 'EA');
          this._form.controls['receiveunitofmeasure'].setValue(
            defaultUOM ?? []
          );
          this._form.controls['inventoryunitofmeasure'].setValue(
            defaultUOM ?? []
          );
          this._form.controls['issueunitofmeasure'].setValue(defaultUOM ?? []);
        }

        // if(this.reloaduom > 0)
        // {
        //   this._form.controls['receiveunitofmeasure'].setValue(this.reloaduom );
        // this._form.controls['inventoryunitofmeasure'].setValue(this.reloaduom );
        // this._form.controls['issueunitofmeasure'].setValue(this.reloaduom );
        // }
      });
  }

  _LoadItemTypesDD() {
    let model = { accountIds: this.getSelectedAccountIds() };
    return this._stockItemsService
      .getAccountItemTypes(model)
      .subscribe((data: any) => {
        this._itemTypes = data;

        if (!this._model?.id && !this.isCopySelection) {
          this._form.controls['itemtype'].setValue(
            this._itemTypes?.find((x) => x.name == 'Standard') ?? []
          );
        }
      });
  }

  _LoadCostTypesDD() {
    let model = { accountIds: this.getSelectedAccountIds() };

    return this._stockItemsService.getAccountCostTypes(model).subscribe((data: any) => {
      this._costTypes = data;

      if (!this._model?.id && !this.isCopySelection) {
        this._form.controls['costtype'].setValue(this._costTypes?.find((x) => x.code == 'Last/Simple') ?? []);
      }
    });
  }

  _loadLocationsDD(siteId: number) {
    if (!siteId)
      siteId = 0;
    return this._locationsService.getLocationListingBySite(siteId).subscribe((data: any) => {
      this._locations = data;
      this._locationsFiltered = data;

      const modelAny = this._model as any;
      const locationId = modelAny?.defaultLocationId || modelAny?.defaultLocation?.id || modelAny?.locationId || modelAny?.location?.id;
      if (locationId && this._pageState === PageState.ADD) {
        const matchingLocation = this._locationsFiltered?.find((f: any) => f.id === locationId);
        if (matchingLocation && this._form) {
          this._form.patchValue({
            defaultLocation: matchingLocation
          });
        }
      }

      //       if (this._model?.iskit) {
      //   if(this._model.stockItemKitDetails)
      //   {
      //     this._locationsFiltered
      //   }
      // }
    });
  }

  _onStateChanges(e: any) {
    var element: any = this.kendoMainWindow;
    if (e === 'minimized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    } else if (e === 'maximized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    } else if (e === 'default') {
      element.el.nativeElement.classList.add('fullWidthFormForm');
    }
  }

  ngOnDestroy() {
    this._layoutManager.removeOverlay();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this._innerWidth = window.innerWidth;
    if (this._innerWidth > 450) {
      this._hiddenWindow = 'hidden';
      this._maximized = 'maximized';
    } else {
      this._hiddenWindow = '';
      this._maximized = 'default';
    }
    let windowSize = window.innerWidth;

    if (windowSize <= 991) {
      this._kendoTabStripPosition = 'top';
    } else {
      this._kendoTabStripPosition = 'left';
    }
  }
  _generateBarcodeClick() {
    this.runGenerateBarcode();
  }
  _selectImagesHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccounts.length) {
        this._showImagesGrid = true;
      } else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true,
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      this._showImagesGrid = true;
    }
  }

  _selectDocumentsHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccounts.length) {
        this._showDocumentGrid = true;
      } else {
        this._layoutComponent.openPopup({
          title: 'validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true,
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      this._showDocumentGrid = true;
    }
  }

  _selectLocationMinMaxHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccounts.length) {
        this._showLocationMinMax = true;
      } else {
        this._layoutComponent.openPopup({
          title: 'validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true,
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      this._showLocationMinMax = true;
    }
  }

  _selectVendorsHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccounts.length) {
        this._showVendorsGrid = true;
      } else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true,
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      this._showVendorsGrid = true;
    }
  }

  _returnSelectedImagesHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccounts.length) {
        this._showImagesGrid = false;
        this._selectedImagesKeys = this._selectedImages;
        this._addStockPic();
      } else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true,
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      this._showImagesGrid = false;
      this._selectedImagesKeys = this._selectedImages;
      this._addStockPic();
    }
  }

  _returnSelectedDocumentsHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccounts.length) {
        this._showDocumentGrid = false;
        this._selectedDocumentsKeys = this._selectedDocuments;
        this._addStockDoc();
      } else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true,
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      this._showDocumentGrid = false;
      this._selectedDocumentsKeys = this._selectedDocuments;
      this._addStockDoc();
    }
  }

  _returnSelectedVendorsHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccounts.length) {
        this._showVendorsGrid = false;
        this._selectedVendorsKeys.forEach((x) => {
          this._selectedVendors.push(x);
        });
        this._selectedVendorsKeys = this._selectedVendors;
        this._loadSelectedVendor();
        this._addStockVendors();
      } else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site  ',
          withoutConfirm: true,
        });
      }
    } else if (!this._currentUser.isEnterprise) {
      this._showVendorsGrid = false;
      this._selectedVendorsKeys.forEach((x) => {
        this._selectedVendors.push(x);
      });
      this._selectedVendorsKeys = this._selectedVendors;
      this._loadSelectedVendor();
      this._addStockVendors();
    }
  }

  _returnSelectedLocationHandler(e: any): void {
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccounts.length) {
        this._showLocationMinMax = false;
        this._addLocationMinMax();
      }
      else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true,
        });
      }
    }
    else if (!this._currentUser.isEnterprise) {
      this._showLocationMinMax = false;
      this._addLocationMinMax();
    }
  }

  _customFieldsValueChanges(customFieldsValue: any = [], tabId: number) {
    // Object.keys(customFieldsValue).forEach(key => {
    //   if (customFieldsValue[key] == null || customFieldsValue[key] == "null") {
    //     customFieldsValue[key] = "";
    //   }
    //   if (this._customFields[tabId].find(x => x.name == key).entityId == undefined) {//new mode, custom field data not added yet
    //     this._customFields[tabId].find(x => x.name == key).entityId = -1;
    //     this._customFields[tabId].find(x => x.name == key).customFieldsData.push({ id: -1, value: "null", entityId: -1 });
    //   }
    //   var customFieldData = this._customFields[tabId].find(x => x.name == key).customFieldsData.find(x => x.entityId == this._customFields[tabId].find(x => x.name == key).entityId);
    //   if (customFieldData != undefined) {
    //     customFieldData.value = customFieldsValue[key];
    //   }
    //   let item = null;
    //   this._customFieldsValue.forEach((e2: any) => {
    //     if (typeof e2[key] != 'undefined') {
    //       item = e2;
    //     }
    //   });
    //   if (item != null) {
    //     let index = this._customFieldsValue.indexOf(item);
    //     if (index != -1) {
    //       this._customFieldsValue.splice(index, 1);
    //     }
    //   }
    //   this._customFieldsValue.push(customFieldsValue);
    // });
    // this._customFieldsValue = this._customFieldsValue.filter(obj => obj !== customFieldsValue);

    // this._customFieldsValue.push(customFieldsValue);
    Object.keys(customFieldsValue).forEach((key) => {
      let customObject = {
        Key: key,
        Value: customFieldsValue[key],
      };
      let item = null;
      this._customFieldsValue.forEach((elementz: any) => {
        if (elementz.Key == key) {
          item = elementz;
        }
      });
      if (item != null) {
        let index = this._customFieldsValue.indexOf(item);
        if (index != -1) {
          this._customFieldsValue.splice(index, 1);
        }
      }
      var requiredCustomerField = this._customValidation.find(
        (x: any) => x.name == key
      );
      if (requiredCustomerField) {
        let item2 = null;
        this._customValidation.forEach((element: any) => {
          if (element.name == key) {
            item2 = element;
          }
        });
        if (item2 != null) {
          let index2 = this._customValidation.indexOf(item2);
          if (index2 != -1) {
            //this._customValidation.splice(index2, 1);
            this._customValidation[index2].value = customObject.Value;
          }
          //this._customValidation.push({'name': customObject.Key, 'value': customObject.Value})
        }
      }
      this._additionalErrors = [];
      if (this._customValidation.find((x: any) => !x.value)) {
        this._additionalErrors.push("Additional Error");
        this._additionalErrors = [];
      }
      this._customFieldsValue.push(customObject);
    });
  }

  _onTabSelect(e: any) {
    this._mobileMenuToggle();
    if (e.title == 'Vendors') {
      this._loadSelectedVendor();
    }
    if (e.title == 'General') {
      this._loadRequiredGeneralTab();
      this.costingTab.selected = false;
      this.costingTab.disabled = false;
    }
    if (e.title == 'Costing') {
      this._loadRequiredCostingTab();
    }
  }

  ClosePopup(event: boolean) {
    if (event == true) {
      this._closeCustomFields();
    }
  }

  _mobileMenuToggle() {
    let mobiletabstrip = this.navTrigger.nativeElement.querySelector('ul');
    if (mobiletabstrip.classList != undefined) {
      mobiletabstrip.classList.toggle('visibletab');
    }
  }

  _onSelectedImagesChanged(e: any[]) {

  }

  _onSelectedImagesRowChanged(e: any[]) {

  }
  _closeImagesWindow(): void {
    this._showImagesGrid = false;
    this._isDialiog = false;
  }

  _closeDocumentsWindow(): void {
    this._showDocumentGrid = false;
  }

  _onImageRowSelectionChanges(e: any[]) {
    this._selectedImages = [];
    e.forEach((item) => {
      this._selectedImages.push(+item);
    });
  }

  _onImageObjectRowSelectionChanges(e: any[]) {
    this._selectedObjectImages = [];
    e.forEach((item) => {
      this._selectedObjectImages.push(item);
    });
  }

  _addStockPic(fileData: any = null) {
    if (fileData == null) {
      this._stockItemFilesPics = this._stockItemFilesPics === null ? [] : this._stockItemFilesPics;

      if (this._selectedObjectImages.length > 0) {
        this._selectedObjectImages.forEach((element: any) => {
          let exists = this._stockItemFilesPics.find((f) => f.fileid == element.id);

          if (exists == undefined) {
            delete element.fileAccounts;

            let stockItemFile: StockItemFile = new StockItemFile();

            stockItemFile.fileid = element.id;
            stockItemFile.filename = element.name;
            stockItemFile.file = element;
            stockItemFile.stockItemId = this._model.id ? this._model.id : 0;
            stockItemFile.status = EntityStatusOptions.Active;

            this._stockItemFilesPics.push(stockItemFile);
          }
        });
      }
    }
    else {
      let stockItemFile: StockItemFile = new StockItemFile();
      stockItemFile.fileid = fileData.response.id;
      stockItemFile.filename = fileData.response.name;
      stockItemFile.file = fileData.picObject.file;
      stockItemFile.stockItemId = this._model.id ? this._model.id : 0;
      stockItemFile.status = EntityStatusOptions.Active;
      this._stockItemFilesPics.push(stockItemFile);
    }
  }
  /* _getActivePics = (params?: any, model?: any): Observable<any[]> => {
    let data = this._stockItemFilesPics.filter(f => f.status == EntityStatusOptions.Active);
    let dataAny: any[] = [...data];
    return of(dataAny);
  } */

  // Video handlers
  _selectVideosHandler(e: any): void {
    this._showVideosGrid = true;
  }

  _closeVideosWindow(): void {
    this._showVideosGrid = false;
  }

  _onVideoRowSelectionChanges(e: any[]) {
    this._selectedObjectVideos = [];
    e.forEach((item) => {
      this._selectedObjectVideos.push(item);
    });
  }

  _returnSelectedVideosHandler(e: any[]): void {
    this._showVideosGrid = false;
    this._addStockVideo();
  }

  _addStockVideo(fileData: any = null) {
    if (fileData == null) {
      this._stockItemFilesVideo = this._stockItemFilesVideo === null ? [] : this._stockItemFilesVideo;

      if (this._selectedObjectVideos.length > 0) {
        this._selectedObjectVideos.forEach((element: any) => {
          let exists = this._stockItemFilesVideo.find((f) => f.fileid == element.id);

          if (exists == undefined) {
            delete element.fileAccounts;

            let stockItemFile: StockItemFile = new StockItemFile();

            stockItemFile.fileid = element.id;
            stockItemFile.filename = element.name;
            stockItemFile.file = element;
            stockItemFile.stockItemId = this._model.id ? this._model.id : 0;
            stockItemFile.status = EntityStatusOptions.Active;

            this._stockItemFilesVideo.push(stockItemFile);
          }
        });
      }
    }
    else {
      let stockItemFile: StockItemFile = new StockItemFile();
      stockItemFile.fileid = fileData.response.id;
      stockItemFile.filename = fileData.response.name;
      stockItemFile.file = fileData.picObject.file;
      stockItemFile.stockItemId = this._model.id ? this._model.id : 0;
      stockItemFile.status = EntityStatusOptions.Active;
      this._stockItemFilesVideo.push(stockItemFile);
    }
  }

  _removeVideoHandler(event: StockItemFile): void {
    const index = this._selectedObjectVideos.indexOf(event, 0);
    if (index > -1) {
      this._selectedObjectVideos.splice(index, 1);
    }
    const stockIndex = this._stockItemFilesVideo.indexOf(event, 0);
    if (stockIndex > -1) {
      this._stockItemFilesVideo.splice(stockIndex, 1);
    }
  }

  _getVideos = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    if (model != null && model.filter != null) {
      return this._filesService.getVideos(params, model);
    }
  }

  _onDocumentsRowSelectionChanges(e: any[]) {
    this._selectedDocuments = [];

    e.forEach((item) => {
      this._selectedDocuments.push(+item);
    });
  }

  _onLocationMinMaxRowSelectionChange(e: any[]) {
    this._selectedObjectLocationMinMax = [];
    e.forEach((item) => {
      this._selectedObjectLocationMinMax.push(item);
    });
  }

  _onDocumentObjectRowSelectionChange(e: any[]) {
    //this._selectedObjectDocuments = [];
    e.forEach((item) => {
      this._selectedObjectDocuments.push(item);
    });
    //this._selectedObjectDocuments = e;
  }

  _addStockDoc(fileData: any = null) {
    if (fileData == null) {
      this._stockItemFilesDoc =
        this._stockItemFilesDoc === null ? [] : this._stockItemFilesDoc;

      if (this._selectedObjectDocuments.length > 0) {
        this._selectedObjectDocuments.forEach((element: any) => {
          let exists = this._stockItemFilesDoc.find((f) => f.fileid == element.id && f.status == EntityStatusOptions.Active);

          if (exists == undefined) {
            let stockItemFile: StockItemFile = new StockItemFile();
            stockItemFile.fileid = element.id;
            stockItemFile.filename = element.name;
            stockItemFile.file = element;
            stockItemFile.stockItemId = this._model.id ? this._model.id : 0;
            stockItemFile.status = EntityStatusOptions.Active;
            this._stockItemFilesDoc.push(stockItemFile);
          }
        });
      }
    }
    else {
      let stockItemFile: StockItemFile = new StockItemFile();
      stockItemFile.fileid = fileData.response.id;
      stockItemFile.filename = fileData.response.name;
      stockItemFile.file = fileData.picObject.file;
      stockItemFile.stockItemId = this._model.id ? this._model.id : 0;
      stockItemFile.status = EntityStatusOptions.Active;
      this._stockItemFilesDoc.push(stockItemFile);
    }
  }

  _closeVendorsWindow(): void {
    this._showVendorsGrid = false;
  }

  _closeLocationWindow(): void {
    this._showLocationMinMax = false;
  }

  _onVendorRowSelectionChanges(e: any[]) {
    this._selectedVendors = [];
    e.forEach((item) => {
      this._selectedVendors.push(item);
    });
  }

  _onVendorObjectRowSelectionChange(e: any[]) {
    this._selectedObjectVendors = [];
    // e.forEach((item) => {
    //   this._selectedObjectVendors.push(item);
    // });
    this._selectedObjectVendors = e;
  }

  _addStockVendors(dataItem: any = null) {
    if (dataItem == null) {
      this._stockItemVendor =
        this._stockItemVendor === null ? [] : this._stockItemVendor;

      if (this._selectedObjectVendors.length > 0) {
        this._selectedObjectVendors.forEach((element: any) => {
          let stockItemVendor: StockItemVendor = new StockItemVendor();
          stockItemVendor.code = element.code;
          stockItemVendor.vendorId = element.id;
          stockItemVendor.vendor = element;
          if (this._stockItemVendor.find((x) => x.code == stockItemVendor.code) == null) {
            this._stockItemVendor.push(stockItemVendor);
          }
          else {
            this._layoutComponent.openPopup({
              title: 'Duplicate',
              message: 'This Vendor is already selected!',
              withoutConfirm: true,
            });
          }
        });
      }
    }
    else {
      if (this._stockItemVendor.find((x) => x.code == dataItem.code) == null) {
        let stockItemVendor: StockItemVendor = new StockItemVendor();

        stockItemVendor.code = dataItem.code;
        stockItemVendor.vendorId = dataItem.id;
        stockItemVendor.vendor = dataItem;
        this._stockItemVendor.push(stockItemVendor);
      }
      else {
        this._layoutComponent.openPopup({
          title: 'Duplicate',
          message: 'This Vendor is already selected!',
          withoutConfirm: true,
        });
      }
    }
  }

  _onLocationMinMaxObjectRowSelectionChange(e: any[]) {
    this._selectedObjectLocationMinMax = [];
    this._selectedObjectLocationMinMax = e;
  }

  _addLocationMinMax() {
    this._stockItemLocationMinMax = this._stockItemLocationMinMax === null ? [] : this._stockItemLocationMinMax;

    if (this._selectedObjectLocationMinMax.length > 0) {
      this._selectedObjectLocationMinMax.forEach((element: any) => {
        let stockItemLocationMinMax: StockLocationMinMax = new StockLocationMinMax();
        // stockItemLocationMinMax.location.code = element.code;
        stockItemLocationMinMax.locationId = element.id;
        stockItemLocationMinMax.location = element;

        this._stockItemLocationMinMax.push(stockItemLocationMinMax);
      });
    }
  }

  _onSave(e: any) {
    this.submit(e);
  }

  _onEditFields() {
    if (!this._currentUser.isEnterprise) {
      this._pageState = PageState.EDIT_FIELDS;
    }
    else {
      if (!this._selectedAccounts.length) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true,
        });
      }
      else {
        this._pageState = PageState.EDIT_FIELDS;
        // this._editFormActive = true;
        // this._isCustomfieldsFormValue = true;
      }
    }
  }

  _onEditForms() {
    this._isEditForms = true;
  }

  _onCloseEditForms(event: boolean) {
    this._isEditForms = event;
    // this._initForm() ;
  }

  CheckIfWeAreInEditMode() {
    var isEditMode: boolean = false;

    if (this._pageState == PageState.EDIT) {
      isEditMode = true;
    }

    return isEditMode;
  }

  _addNewTab() {
    this._editFormActive = true;
    this._isAddTabFormValue = true;
    this._isRenameLabel = false;
    this._selectedLabelId = null;
  }
  _addNewField(tabId: number) {
    this._selectedLabelId = null;
    this._selectedTabId = tabId;
    this._editFormActive = true;
    this._isCustomfieldsFormValue = true;
    this._isRenameLabel = false;
  }
  // _deactivateTab(tabId: number, page: string) {
  //   let model: any = {
  //     customFieldEntityId: page == 'stockItems' ? 1 : 2,
  //     page: this._page,
  //     accountIds: this._selectedAccountIds,
  //   };
  //     if (response != null && response['message'] != null) {
  //         //get custom tabs first
  //         this._customTabs = data.filter((x: { isCustom: boolean }) => x.isCustom == true);
  //       });

  //       this._layoutComponent.openPopup({
  //         title: 'Alert',
  //         message: response['message'],
  //         withoutConfirm: true,
  //       });

  //       this.getFormTabs();

  //       if (response['close'] != null) {
  //         if (response['close'] == true) {
  //           // this._closeForm();
  //         }
  //         else {
  //           return;
  //         }
  //       }
  //     }
  //     //   this._closeForm();
  //   });
  // }

  _openRenameForm(objectCode: string, isMandatory: boolean = false) {
    this._selectedLabelObjectCode = objectCode; //todo send system field label id
    //return; //open form once label id is set

    this._editFormActive = true;
    this._isRenameFormValue = true;
    this._isRenameCustomFormValue = false;
    this._isRenameLabel = true;
    this._isMandatory = isMandatory;
  }

  _openCustomRenameForm(customFieldId: number, tabId: number) {
    this._selectedLabelId = customFieldId;
    this._selectedTabId = tabId;
    this._editFormActive = !isNaN(customFieldId);
    this._isRenameFormValue = !isNaN(customFieldId);
    this._isRenameCustomFormValue = !isNaN(customFieldId);
    this._isRenameLabel = false;
    this._isMandatory = false;
  }

  _removeCustomField(customFieldId: number) {
    for (var i = 1; i <= this._customFields.length; i++) {
      if (this._customFields[i] != null) {
        if (this._customFields[i].findIndex((x) => x.id == customFieldId) != -1) {
          this._customFields[i] = this._customFields[i].filter((x) => x.id != customFieldId);

          return;
        }
      }
    }
  }
  _viewInactiveFormTabs(onLoad: boolean = false) {
    this._customFieldsService
      .getDeactivatedCustomForms(this._page)

      .subscribe((data: Array<any>) => {
        this._deactivatedFormTabsGridData = data;
        //  if(!onLoad)
        //  this._deactivatedFormTabsForm = true;
      });
  }
  reactivateTab: boolean;
  _reactivateFormTab(item: any) {
    this.reactivateTab = true;
    const sub = this._sharedService.okCloseClicked.subscribe((boolData: boolean) => {
      this.reactivateTab = true;
      if (boolData && this.reactivateTab) {
        // if (boolData && this.reactivateTab && (this.lastTabIdReactivated.length == 0 || !this.lastTabIdReactivated.includes(item.id))) {
        this.reactivateTab = false;
        let model: any = {
          customFieldEntityId: 1,
          page: this._page,
          accountIds: this._selectedAccountIds,
        };
        this._customFieldsService
          .reactivateFormTab(item.id, model)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              // if (this.lastTabIdDeactivated.includes(item.id)) {
              //   this.lastTabIdDeactivated = this.lastTabIdDeactivated.filter(id => id !== item.id);
              // }
              // this.lastTabIdReactivated.push(item.id);
              this._viewInactiveFormTabs(false)
              this._customFieldsService
                .getFormTabsByPage(this._page)

                .subscribe((data: any) => {
                  //get custom tabs first
                  this.getFormTabs();
                  this._customTabs = data.filter((x: { isCustom: boolean; }) => x.isCustom == true);
                });
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                } else {
                  return;
                }
              }
            }
          });
      } else {
        this.reactivateTab = false;
      }
      sub.unsubscribe();
    });


    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name
    });
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
  }
  _closeInactiveFormTabs() {
    this._deactivatedFormTabsForm = false;
  }
  // lastTabIdDeactivated:number[] = []
  // lastTabIdReactivated:number[] = []
  //#endregion
  deactivateTab: boolean
  _deactivateTab(tabId: number, page: string) {
    this.deactivateTab = true;
    const sub = this._sharedService.okCloseClicked.subscribe((boolData: boolean) => {
      if (boolData && this.deactivateTab) {
        // if (boolData && this.deactivateTab && (this.lastTabIdDeactivated.length == 0 || !this.lastTabIdDeactivated.includes(tabId))) {
        this.deactivateTab = false;
        let model: any = {
          customFieldEntityId: 1,
          page: this._page,
          accountIds: this._selectedAccountIds,
        };
        this._customFieldsService.deleteCustomTab(tabId, model).subscribe((response: any) => {
          // this.lastTabIdDeactivated.push(tabId);
          // if (this.lastTabIdReactivated.includes(tabId)) {
          //   this.lastTabIdReactivated = this.lastTabIdReactivated.filter(id => id !== tabId);
          // }

          if (response != null && response['message'] != null) {
            this._customFieldsService.getFormTabsByPage(this._page).subscribe((data: any) => {
              //get custom tabs first
              this.getFormTabs();
              this._customTabs = data.filter((x: { isCustom: boolean }) => x.isCustom == true);
            });

            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });

            if (response['close'] != null) {
              if (response['close'] == true) {
                // this._closeForm();
              }
              else {
                return;
              }
            }
          }
        });
      } else {
        this.deactivateTab = true;
      }
      sub.unsubscribe();
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Deactivate This Tab?',
    });

  }


  _returnAdNew() {
    this._pageState = PageState.ADD;
    if (this._deactivatedFormTabsGridData?.length == 0) {
      this._viewInactiveFormTabs(true);
    }
  }

  _onCancel() {
    this._closeForm();
  }

  _closeForm(model?: any) {
    var closeComponent = {
      component: 'stockItems',
      isClosed: true,
      response: this.openfromlist === true ? null : model,
    };

    this._active = false;
    this._gridLayoutManagerService.setGridDataSubjects('stockItems');
    this._sharedService.closeDialog.emit(closeComponent);
    this._dataService.push(closeComponent);
    this._sharedService.model = {};
  }

  getAccountsString(accountSites: any) {
    let accounts = '';
    let counter = 0;

    accountSites.forEach((element: any) => {
      if (counter > 0) {
        accounts += ', ';
      }

      accounts += element.account.name;
      counter++;
    });

    return accounts;
  }

  getCategoryImage(categoryFiles: any): any {
    var PrimaryImage = '';
    let HasPrimaryImage = categoryFiles.find((x: any) => x.categoryFilePrimary == true);
    categoryFiles.forEach((element: any) => {
      if (HasPrimaryImage && element.categoryFilePrimary) {
        PrimaryImage = EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/' + element.file.thumbnail;
        //return EnvironmentLoaderService.envConfig.enterpriseApiLocal+'/'+ element.file.thumbnail;
      }
      else if (!HasPrimaryImage) {
        PrimaryImage = EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/' + element.file.thumbnail;
      }
    });

    return PrimaryImage;
  }

  // Skip functions:
  // ================
  _StockDescriptionSubmited() {
    if (this._pageState == PageState.ADD) {
      if (this.kendoMultiselectStatus != undefined) {
        this.kendoMultiselectStatus.toggle(true);
      }

      let stockDesc = this.kendoStockDescriptionInput;
      stockDesc.nativeElement.classList.remove('focusedInput');
      stockDesc.nativeElement.blur();
      let statusSelection = this.kendoMultiselectStatus;
      ɵgetHostElement(statusSelection).classList.add('focusedMultiSelect');
    }
  }

  _removeTabActiveaddSkip() {
    if (this._pageState == PageState.ADD) {
      this._addClassActive = false;
      let stockDesc = this.kendoStockDescriptionInput;
      stockDesc.nativeElement.classList.add('focusedInput');
    }
  }

  focusoutremoveskip() {
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        let stockDesc = this.kendoStockDescriptionInput;
        stockDesc.nativeElement.classList.remove('focusedInput');
      }, 100);
    }
  }

  _skipStockDescription() {
    if (this._pageState == PageState.ADD) {
      setTimeout(() => {
        if (this.kendoMultiselectStatus != undefined) {
          this.kendoMultiselectStatus.toggle(true);
          this.kendoMultiselectStatus.focus();
        }
      }, 100);
      let StockDesc = this.kendoStockDescriptionInput;
      StockDesc.nativeElement.classList.remove('focusedInput');
    }
  }

  _skipStatus() {
    if (this._pageState == PageState.ADD) {
      if (this.kendoMultiselectStatus != undefined) {
        this.kendoMultiselectStatus.toggle(false);
      }
      this._addClassActive = true;
      let StatusSelection = this.kendoMultiselectStatus;
      ɵgetHostElement(StatusSelection).classList.remove('focusedMultiSelect');
    }
  }

  _statusMultiSelectFocus() {
    if (this._pageState == PageState.ADD) {
      this._addClassActive = false;
      let StatusSelection = this.kendoMultiselectStatus;
      ɵgetHostElement(StatusSelection).classList.add('focusedMultiSelect');
    }
  }
  // =======================================

  _closeCustomFields() {
    this._editFormActive = false;
    this._isCustomfieldsFormValue = false;
    this._isAddTabFormValue = false;
    this._isRenameFormValue = false;
    // this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
    this.loadLabels();
    this.getFormTabs();
    this.getAuth();
  }

  _statusMultiSelectCloseEvent() {
    if (this._pageState == PageState.ADD) {
      this._addClassActive = true;
      let statusclosedvalue = this.kendoMultiselectStatus;

      ɵgetHostElement(statusclosedvalue).classList.remove('k-state-focused');
      let StatusSelection = this.kendoMultiselectStatus;

      ɵgetHostElement(StatusSelection).classList.remove('focusedMultiSelect');
    }
  }

  _removeTabActive() {
    if (this._pageState == PageState.ADD) {
      this._addClassActive = false;
    }
  }

  private runGenerateBarcode() {
    let counter = 1;
    this.generateBarcode(counter).subscribe((data: any) => {
      this._sitemNumber.setValue(data.result.toString());
      this._form.patchValue({
        number: data.result.toString(),
      });
      // setTimeout(() => {
      //   this.kendoComboboxItemType.toggle(true);
      //   this.kendoComboboxItemType.focus();
      // });
      if (this._pageState == PageState.ADD) {
        setTimeout(() => {
          this.kendoStockDescriptionInput.nativeElement.focus();
          let StockDesc = this.kendoStockDescriptionInput;
          StockDesc.nativeElement.classList.add('focusedInput');
        });
      }
    });
  }

  //#region  generateBarcode
  private generateBarcode(quantity: number) {
    return this._barcodeGeneratorsService.getBarcode('stock-items', quantity);
  }
  //#endregion

  //#region  loadCustomFields
  private loadCustomFields(entityId?: string) {
    this._customFieldsService.getCustomFields('Stock', this._page, entityId).subscribe((data) => {
      if ((this._model != null && this._model.id != null) || this.copyModelId != null) {
        let that = this;

        data.map(function (x) {
          x.entityId = that._model.id ?? that.copyModelId;
        });
      }

      var tabIds = data.map((item) => item.formTabId).filter((value, index, self) => self.indexOf(value) === index);

      const grouped = this.groupBy(data, (item: { formTabId: any }) => item.formTabId);

      let that = this;

      tabIds.forEach(function (formTabId) {
        that._customFields[formTabId] = grouped.get(formTabId);
      });

      if (this.copyModelId) {
        let CustomFieldsDataForCopy: any = {};

        grouped.forEach(element => {
          element.forEach((value: any) => {
            let _cutomfieldData = value.customFieldsData?.find((f: any) => f.entityId == entityId);
            CustomFieldsDataForCopy[value.name] = _cutomfieldData?.value ?? null;

            if (value.customFieldType.type.toLowerCase() == 'date' && CustomFieldsDataForCopy[value.name]) {
              CustomFieldsDataForCopy[value.name] = new Date(CustomFieldsDataForCopy[value.name]);
            }

            if (value.customFieldType.type.toLowerCase() == 'numeric' && CustomFieldsDataForCopy[value.name]) {
              CustomFieldsDataForCopy[value.name] = parseFloat(CustomFieldsDataForCopy[value.name]);
            }
          });

          this._customFieldsValueChanges(CustomFieldsDataForCopy, null);
        });
      }

      this._customFieldsService.getFormTabsByPage(this._page).subscribe((data: any) => {
        //get custom tabs first
        this._customTabs = data.filter((x: { isCustom: boolean }) => x.isCustom == true);
        this.setMandatoryFields();
      });
    });
  }
  //#endregion
  private loadLabels() {
    this._gridFields.getGridFieldTextLabelByPage(this._page, this._language).subscribe((data: GridFieldTextSummary[]) => {
      this._gridFieldText = data;
      this._initForm();
      if (this.isReceived) {
        this._form.get('costtype')?.disable()
        this._form.get('itemtype')?.disable()
        this._form.get('inventoryunitofmeasure')?.disable()
        this._form.get('receiveunitofmeasure')?.disable()
        this._form.get('issueunitofmeasure')?.disable()
      }

    });
  }

  groupBy(list: any[], keyGetter: any) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);

      if (!collection) {
        map.set(key, [item]);
      }
      else {
        collection.push(item);
      }
    });
    return map;
  }

  // _openForm(componentName: string, isDocument = false) {
  //   this._dialogComponentName = componentName;
  //   this._dialogModel = { model: {}, pageState: PageState.ADD, isDocument };
  //   this._isDialiog = true;
  //   //this._isMandatory = false ;
  // }

  selectedobjectname: string = null;
  _openForm(componentName: string, isDocument = false, objectname: any = null) {
    if (componentName != 'categoires') {
      this._isDialiog = true;
      this._dialogComponentName = componentName;
      this._dialogModel = {
        model: {},
        pageState: PageState.ADD,
        reload: 'model',
        fileSource: fileSources.stockItem,
      };

      this._isMandatory = false;
      this.selectedobjectname = objectname;
    }
    else {
      this.ShowCategoryForm = true;
    }
  }

  reloaduom: number = 0;
  _closeDialog(fileData: any) {
    if (fileData?.response) {
      switch (fileData.component) {
        case 'locationTypes':
          //             this._loadLocationTypesList();
          this._form.get('locationType').setValue(fileData.response);
          this._isDialiog = fileData.open;
          break;

        case 'vendors':
          // this._vendorsService
          //   .getVendor(fileData?.response.id)
          //   .subscribe((data: any) => {
          //     // this._selectedVendorsKeys.push(data.id);
          //     // this._selectedVendorsKeys.forEach((x) => {
          //     //   this._selectedVendors.push(x);
          //     // });
          //     // this._selectedVendorsKeys = this._selectedVendors;
          //     var stockItemVendor = new StockItemVendor();
          //     stockItemVendor.vendor = data;
          //     stockItemVendor.vendorId = data.id;
          //     stockItemVendor.code = data.code;
          //     stockItemVendor.vendor.name = data.name;
          //     this._stockItemVendor.push(stockItemVendor);
          //     this._loadSelectedVendor();
          //     this._addStockVendors();
          //   });
          this._isDialiog = fileData.open;
          break;
          break;
        case 'locations':
          const loggedInAccountSites =
            localStorage.getItem('loggedInAccountSites') ?? '';
          var siteId = JSON.parse(loggedInAccountSites)[0].siteId;
          this._loadLocationsDD(siteId);
          this._form.controls['defaultLocation'].setValue(fileData.response);
          this._isDialiog = fileData.open;
          break;

        case 'uom':
          let model = {
            accountIds: this.getSelectedAccountIds(),
          };
          if (this.selectedobjectname != null) {
            this._form.get(this.selectedobjectname).setValue(fileData?.response);
          }
          break;

        case 'categories':
          let model1 = {
            accountIds: this.getSelectedAccountIds(),
          };
          // this._categoriesService
          //   .getAccountCategories(model1)
          //   .subscribe((data: any) => {
          // this._categories = data;
          // this._categoriesFiltered = this._categories;
          // this._form.get('category').setValue(fileData.response);
          //this._isDialiog = fileData.open;
          //this.ShowCategoryForm = false;
          //});

          break;
      }
    } else if (fileData?.response && fileData.component == 'vendors') {
      // this.GetImageById(event.response);
      // this._isDialiog = event.open;
      //this.GetVendorById(fileData.response);
      this._isDialiog = fileData.open;
    } else {
      this._isDialiog = fileData;
    }
    this._isDialiog = false;
  }

  GetImageById(id: number) {
    this._filesService
      .getFile(id)
      .pipe()
      .toPromise()
      .then((data) => {
        var stockItemFile = new StockItemFile();
        stockItemFile.file = data;
        stockItemFile.fileid = id;
        stockItemFile.status = EntityStatusOptions.Active;

        this._stockItemFilesPics.push(stockItemFile);
      });
  }
  _selectedMaterialRows: any = {};
  public checkboxOnly = false;
  public mode: SelectableMode = "multiple";
  public drag = false;
  public selectableSettings: SelectableSettings;
  public setSelectableSettings(): void {
    if (this.checkboxOnly || this.mode === "single") {
      this.drag = false;
    }

    this.selectableSettings = {
      checkboxOnly: this.checkboxOnly,
      mode: this.mode,
      drag: this.drag,
    };
  }
  onSelectionChange(event: any): void {
    this._selectedMaterialRows = event.selectedRows[0];
    if (this._selectedMaterialRows == undefined) {
      this._selectedShowList = this._selectedKitSubList;
    }
    else {
      this._selectedShowList = this._selectedKitSubList.filter((x: any) => x.primaryStockId == this._selectedMaterialRows.dataItem.id);
    }
  }
  onCellBlur(): void {
    // Handle cellBlur action here
    this._selectedMaterialRows = {};
    this._selectedShowList = this._selectedKitSubList.filter((x: any) => x.primaryStockId == this._selectedMaterialRows?.dataItem.id);
    // Add your logic to handle the cellBlur action
  }
  onCellEdit(event: any): void {
    // Handle cell edit mode here
  }
  GetDocById(id: number) {
    this._filesService
      .getFile(id)
      .pipe()
      .toPromise()
      .then((data) => {
        var stockItemFile = new StockItemFile();
        stockItemFile.file = data;
        stockItemFile.fileid = id;
        stockItemFile.status = EntityStatusOptions.Active;

        this._stockItemFilesDoc.push(stockItemFile);
      });
  }

  GetVendorById(id: number) {
    this._vendorsService
      .getVendor(id)
      .subscribe((data) => {
        var stockItemVendor = new StockItemVendor();
        stockItemVendor.vendor = data;
        stockItemVendor.vendorId = id;
        stockItemVendor.code = data.code;
        stockItemVendor.vendor.name = data.name;
        //stockItemVendor.code
        this._stockItemVendor.push(stockItemVendor);
      });
  }

  _onAccountRowSelectionChanges(e: any[]) {
    super._onAccountRowSelectionChanges(e, () => {
      this._LoadCategoriesDD();
      this._LoadUnitOfMeasuresDD();
      this._loadLocationsDD(this._selectedAccounts[0].siteId);
      this._stockItemVendor = [];
    });
  }

  _loadSelectedVendor() {
    let modelParam: any = {
      deleted: 'false',
      pageSize: this._selectedVendorsKeys.length,
    };
    const model = {
      filter: {},
      selectedIds: this._selectedVendorsKeys,
    };

    this._vendorsService
      .getVendors(modelParam, model)
      .pipe(map(augmentForKendo))
      .subscribe((data: any) => {
        this._vendors = data.data.value ?? data.data;

        this._loadVendorsDropDown();
      });
  }
  _loadRequiredGeneralTab() {
    setTimeout(() => {
      // this.loadCustomFields(this._model?.id?.toString());
    });
  }
  _loadRequiredCostingTab() {
    // setTimeout(() => {
    //   this.KendoComboboxCostType.toggle(true);
    //   this.KendoComboboxCostType.focus();
    // });
  }
  _loadVendorsDropDown(search?: string) {
    let modelParam: any = {
      search: search,
      deleted: 'false',
    };

    const model = {
      filter: {},
    };
    this._vendorsService.getAccountsVendors(this.getSelectedAccountIds(), modelParam, model).subscribe((data: any) => {
      this._commonVendors = data.data.value ?? data.data;
    });
    /*
        this._vendorsService
          .getVendors(modelParam, model)
          .pipe(map(augmentForKendo))
          .subscribe((data: any) => {
            if (data) {
              if (!search) {
                data.data.forEach((v: any) => {
                  if (!this._vendors.find((x) => x.id == v.id)) {
                    this._vendors.push(v);
                  }
                });
              } else {
                this._vendors = data.data;
              }
            }

            if (this._vendors.length) {
              this._vendorsFiltered = this._vendors.map((x: any) => x.code);
            }

            // if (!this._vendorGridData || this._vendorGridData.length == 0) {
            this._loadVendorsGrid();
            // }
          });
          */
  }

  _loadVendorsGrid() {
    if (this._vendors.length) {
      this._vendorGridData = [];

      this._vendors
        .filter((x) => this._selectedVendorsKeys.includes(x.id))
        .forEach((item) => {
          this._vendorGridData.push({
            id: item.id,
            code: item.code,
            price: 2,
            vendorStockNumber: 1,
            name: item.name,
            preferedVendor: '',
          });
        });
    }
  }
  // this._model.stockItemAlternates
  // _loadAlternateStocksGrid() {
  //   if (this._selectedStockAlternatesKeys.length) {
  //     this._stockAlternateGridData = [];
  //     this._selectedStockAlternatesKeys.forEach((item) => {
  //       this._stockAlternateGridData.push({
  //         code: item,
  //       });
  //     });
  //   }
  // }

  _loadAlternateStocksGrid2() {
    if (this._model.stockItemAlternates.length) {
      this._stockAlternateGridData = [];
      this._model.stockItemAlternates.forEach((item, index) => {
        this._stockAlternateGridData.push({
          id: item.id,
          code: item.code,
          rowindex: index + 1,
        });
      });
    }
  }
  loadStockAlternateAfterUpdate(listafterupdate: any[]) {
    this._stockAlternateGridData = [];
    listafterupdate.forEach((item, index) => {
      this._stockAlternateGridData.push({
        id: item.id,
        code: item.code,
        rowindex: index + 1,
      });
    });
  }

  _loadStatus() {
    var costInfo = this._model.costInfo;
    if (costInfo) {
      if (costInfo.isCalculatedPrice)
        this._selectedItemStatusCosting = this._itemStatusCosting[1];
      else if (costInfo.isFixedPrice)
        this._selectedItemStatusCosting = this._itemStatusCosting[0];
    }
  }

  _handleVendorsFilters(value: any) {
    this._loadVendorsDropDown(value);
  }

  _handleVendorSelection(value: any, id: number) {
    if (id) {
      const newVendor = this._vendors.find((x) => x.code == value);

      if (this._selectedVendorsKeys.find((x) => x === newVendor.id)) {
        this._layoutComponent.openPopup({
          title: 'Duplicate',
          message: 'This Vendor is already selected!',
          withoutConfirm: true,
        });
      } else {
        this._vendorGridData.find((x: any) => x.id == id).code = newVendor.code;
        this._vendorGridData.find((x: any) => x.id == id).name = newVendor.name;
        this._vendorGridData.find((x: any) => x.id == id).id = newVendor.id;

        this._selectedVendorsKeys.push(newVendor.id);
        this._selectedVendorsKeys = this._selectedVendorsKeys.filter(
          (x) => x != id
        );
      }
    }
  }

  _addHandler({ sender }: any) {
    this._vendorForm = this._fb.group({
      id: '',
      code: '',
      name: '',
      price: 0,
      vendorStockNumber: '',
      preferedVendor: '',
    });

    sender.addRow(this._vendorForm);

    this._vendorForm.get('code').valueChanges.pipe(debounceTime(500)).subscribe((x) => {
      const newVendor = this._vendors.find((v) => v.code == x);

      if (newVendor) {
        if (this._selectedVendorsKeys.find((x) => x === newVendor.id)) {
          this._layoutComponent.openPopup({
            title: 'Duplicate',
            message: 'This Vendor is already selected!',
            withoutConfirm: true,
          });
        } else {
          this._vendorForm
            .get('id')
            .setValue(this._vendors.find((v) => v.code == x).id);
          this._vendorForm
            .get('name')
            .setValue(this._vendors.find((v) => v.code == x).name);
        }
      }
    });
  }

  _addKitHandler({ sender }: any) {
    this._vendorForm = this._fb.group({
      id: '',
      code: '',
      name: '',
      price: 0,
      vendorStockNumber: '',
      preferedVendor: '',
    });

    sender.addRow(this._vendorForm);

    this._vendorForm.get('code').valueChanges.subscribe((x) => {
      const newVendor = this._vendors.find((v) => v.code == x);

      if (newVendor) {
        if (this._selectedVendorsKeys.find((x) => x === newVendor.id)) {
          this._layoutComponent.openPopup({
            title: 'Duplicate',
            message: 'This Vendor is already selected!',
            withoutConfirm: true,
          });
        } else {
          this._vendorForm.patchValue({
            id: newVendor.id,
            name: newVendor.name
          });
          /* this._vendorForm
            .get('id')
            .setValue(this._vendors.find((v) => v.code == x).id);
          this._vendorForm
            .get('name')
            .setValue(this._vendors.find((v) => v.code == x).name); */
        }
      }
    });
  }

  _cancelHandler({ sender, rowIndex }: any) {
    sender.closeRow(rowIndex);
  }

  _saveHandler({ sender, formGroup, rowIndex }: any) {
    // if user select from library before save this row
    if (
      this._selectedVendorsKeys.find(
        (x) => x === this._vendorForm.get('id').value
      ) ||
      this._vendorGridData.find(
        (x: any) => x.code == this._vendorForm.get('code').value
      )
    ) {
      this._layoutComponent.openPopup({
        title: 'Duplicate',
        message: 'This Vendor is already selected!',
        withoutConfirm: true,
      });
    } else {
      if (this._vendorForm.valid) {
        this._vendorGridData.push({
          id: this._vendorForm.get('id').value,
          code: this._vendorForm.get('code').value,
          name: this._vendorForm.get('name').value,
        });
        this._selectedVendorsKeys.push(this._vendorForm.get('id').value);

        sender.closeRow(rowIndex);
      }
    }
  }

  _removeHandler({ sender, dataItem }: any) {
    const index = this._stockItemVendor.indexOf(dataItem, 0);
    if (index > -1) {
      this._stockItemVendor.splice(index, 1);
    }
    sender.cancelCell();
  }

  _removePicHandler(event: StockItemFile) {
    //event.status = EntityStatusOptions.Deleted;

    const indx = this._selectedObjectImages.indexOf(event.file, 0);
    if (indx > -1) {
      this._selectedObjectImages.splice(indx, 1);
    }

    const index = this._stockItemFilesPics.indexOf(event, 0);
    if (index > -1) {
      this._stockItemFilesPics.splice(index, 1);
    }
  }

  _removePicHandlerFromLibrary(event: StockItemFile) {
    this._deactivate(event);
    this._removePicHandler(event);
  }


  _removeDocHandler(event: any) {
    const indx = this._selectedObjectDocuments.indexOf(event.file, 0);
    if (indx > -1) {
      this._selectedObjectDocuments.splice(indx, 1);
    }

    const index = this._stockItemFilesDoc.indexOf(event, 0);
    if (index > -1) {
      this._stockItemFilesDoc.splice(index, 1);
    }
  }
  _deactivate(item: any) {
    let deactivate = true;
    this._sharedService.okCloseClicked.subscribe((data: boolean) => {
      if (data && deactivate) {
        deactivate = false;
        this._layoutComponent.openDialogForm(
          StocksDeactivatingDataComponent,
          PageState.VIEW,
          { itemId: item.file.id, pageName: 'files' }
        );
      } else {
        deactivate = false;
      }
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message:
        'Are you sure you want to deactivate the file  ' +
        item.filename +
        '?' +
        '<br/>' +
        'If yes , the file  ' +
        item.filename +
        ' will be moved to deactivated data.',
    });
  }

  _removeLocMinMaxHandler(event: StockLocationMinMax) {
    const index = this._stockItemLocationMinMax.indexOf(event, 0);
    if (index > -1) {
      this._stockItemLocationMinMax.splice(index, 1);
    }
  }

  //Stock Alternate handlers
  _addHandlerStockAlternate({ sender }: any) {
    this._stockAlternateForm = this._fb.group({
      code: '',
      id: 0,
    });

    sender.addRow(this._stockAlternateForm);

    this._stockAlternateForm.get('code').valueChanges.subscribe((x) => {
      const newStockAlternate = x;
      if (newStockAlternate) {
        if (
          this._selectedStockAlternatesKeys.find((x) => x === newStockAlternate)
        ) {
          this._layoutComponent.openPopup({
            title: 'Duplicate',
            message: 'This Stock Alternate is already selected!',
            withoutConfirm: true,
          });
        } else {
          this._stockAlternateForm.get('code').setValue(newStockAlternate);
        }
      }
    });
  }

  _cancelHandlerStockAlternate({ sender, rowIndex }: any) {
    sender.closeRow(rowIndex);
  }

  _saveHandlerStockAlternate({ sender, formGroup, rowIndex }: any) {
    this._stockItemsService
      .getStockItemAlternate(this.alternativeStockItemCode)
      .subscribe((data: any) => {
        if (data == 1) {
          this._layoutComponent.openPopup({
            title: 'Error',
            message: 'Stock Item Alternate Code Already Exist',
            withoutConfirm: true,
          });
          return;
        }

        if (this.alternativeStockItemCode == '') {
          this._layoutComponent.openPopup({
            title: 'Error',
            message: 'Please fill in code value',
            withoutConfirm: true,
          });
          return;
        }

        if (
          this.alternativeStockItemCodes.find(
            (f) => f == this.alternativeStockItemCode
          )
        ) {
          this._layoutComponent.openPopup({
            title: 'Duplicate',
            message: 'This Stock Alternate is already selected!',
            withoutConfirm: true,
          });
        } else {
          this.alternativeStockItemCodes.push(this.alternativeStockItemCode);
          let maxrowindex =
            Math.max(
              ...this._stockAlternateGridData.map((o: any) => o.rowindex),
              0
            ) + 1;
          this._stockAlternateGridData.push({
            id: 0,
            code: this.alternativeStockItemCode,
            rowindex: maxrowindex,
          });
          //this._selectedStockAlternatesKeys.push(this.alternativeStockItemCode);
          this.alternativeStockItemCode = '';
          sender.closeRow(rowIndex);
        }
      });
  }

  _edit() {
    this._pageState = PageState.EDIT;
    //this.accountTab.selected = true;
    this.accountTab.disabled = false;
    /*   this.GeneralTab.disabled = true;
      this.stockInfoTab.disabled = true;
      this.alternateStockItemTab.disabled = true;
      this.picturesTab.disabled = true;
      this.vendorsTab.disabled = true;
      this.HistoricalDataTab.disabled = true;
      this.PendingPOTab.disabled = true;
      this.PendingSOTab.disabled = true;
      this.PendingTransferRequest.disabled = true; */
  }

  stockItemAlternatesDelete: any[] = [];

  _removeHandlerStockAlternate({ sender, dataItem }: any) {
    this._stockAlternateGridData.forEach((x: any) => {
      x.status = 1;

      if (x.rowindex === dataItem.rowindex) {
        x.status = 0;
        this.stockItemAlternatesDelete.push(x);
      }
    });

    this._stockAlternateGridData = this._stockAlternateGridData.filter((x: any) => x.rowindex != dataItem.rowindex);
    sender.cancelCell();
  }

  //end Stock Alternate handlers
  isReceived: boolean;

  private _initForm() {
    if (this._model?.number) {
      this._sitemNumber.setValue(this._model.number, { emitEvent: false });
    }

    this._form = this._fb.group({
      IsTaxable: [this.IsTaxable],
      number: [this._model && this._model.number, Validators.required],
      description: [this._model ? this._model.description : '', this.getLabel('LBL_StockDescription')?.isRequired ? Validators.required : null,],
      itemtype: [(this._model?.id || this.isCopySelection) ? this._model?.itemType : this._itemTypes?.find((x) => x.name == 'Standard') ?? [], Validators.required,],
      iskit: [this._model ? this._model.iskit : false],
      category: [this._model ? this._model.category : [], this.getLabel('LBL_Category')?.isRequired ? Validators.required : null],
      generaldescription: [this._model ? this._model.generalDescription : '', this.getLabel('LBL_GeneralDescription')?.isRequired ? Validators.required : null],
      isShopping: [this._model ? this._model.isShopping : false],
      shoppingUM: [this._model ? this._model.shoppingUM : ""],
      receiveunitofmeasure: [this._model?.id ? this._model.receiveUnitOfMeasure : this._unitOfMeasures?.find((x) => x.code == 'EA') ?? [], Validators.required],
      inventoryunitofmeasure: [this._model?.id ? this._model.inventoryUnitOfMeasure : this._unitOfMeasures?.find((x) => x.code == 'EA') ?? [], Validators.required],
      issueunitofmeasure: [this._model?.id ? this._model.issueUnitOfMeasure : this._unitOfMeasures?.find((x) => x.code == 'EA') ?? [], Validators.required],
      costtype: [(this._model?.id || this.isCopySelection) ? this._model?.costType : this._costTypes?.find((x) => x.code == 'Last/Simple') ?? [], Validators.required],
      cost: [this._model && this._model.costInfo ? this._model.costInfo.cost : 0, this.getLabel('LBL_Cost')?.isRequired ? Validators.required : null],
      calprice: [this._model && this._model.costInfo ? this._model.costInfo.isCalculatedPrice : false],
      pricemarkuppercent: [this._model && this._model.costInfo ? this._model.costInfo.markupPercent : null, this.getLabel('LBL_PriceMarkup%')?.isRequired ? Validators.required : null],
      pricemarkupnumber: [this._model && this._model.costInfo ? this._model.costInfo.markupNumber : null, this.getLabel('LBL_PriceMarkup$')?.isRequired ? Validators.required : null],
      fixedprice: [this._model && this._model.costInfo ? this._model.costInfo.isFixedPrice : false,],
      fixedunitprice: [this._model && this._model.costInfo ? this._model.costInfo.fixedUnitPrice : null, this.getLabel('LBL_FixedUnitPrice')?.isRequired ? Validators.required : null],
      minqty: [this._model ? this._model.minqty : null],
      maxqty: [this._model ? this._model.maxqty : null],
      leadtime: [this._model && this._model.stockItemLeads ? this._model.stockItemLeads[0]?.stockitemleadtime : 0, this.getLabel('LBL_LeadTime')?.isRequired ? Validators.required : null],
      leadtimeduration: [this._model && this._model.stockItemLeads ? this._model.stockItemLeads[0]?.stockitemleadtimeduration : 0],
      leadvar: [this._model && this._model.stockItemLeads ? this._model.stockItemLeads[0]?.stockitemleadinterval : ''],
      allowSubstituteStock: false,
      isInventory: [this._model ? this._model.isInventory : false],
      defaultLocation: [this._model ? this._model.defaultLocation : [], (this._sysReceiveSettings?.defaultLocation ? Validators.required : null) || this.getLabel('LBL_DefaultLocation')?.isRequired ? Validators.required : null]
    });

    this._isKit = this._model ? this._model.iskit : false;
    this._isShopping = this._model ? this._model.isShopping : false;
    this._shoppingUM = this._model ? this._model.shoppingUM : "";

    if (this._isKit && this._selectedItemStatus.filter((obj) => obj.id === 'assemble').length < 1) {
      this._selectedItemStatus.push({ id: 'assemble', title: 'Assemble' });
    }

    if (this._selectedItemStatus.length === 0) {
      this._selectedItemStatus.push({ id: 'regular', title: 'Regular' });
    }
    //this.setMandatoryFields();
  }

  _onStockSiteMinMaxQuantityChange(e: number, item: any, minOrMax: string) {
    if (minOrMax == 'min') {
      if (item.minQty >= item.maxQty && item.maxQty) {
        this.isInvalidMinMax = true;

        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'MaxQnty Must be more than MINQNTY',
          withoutConfirm: true,
        });
      }
      else {
        //item.minQty = e;
        this.isInvalidMinMax = false;
      }
    }
    else if (minOrMax == 'max') {
      if (item.maxQty <= item.minQty && item.minQty) {
        this.isInvalidMinMax = true;
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'MaxQnty Must be more than MINQNTY',
          withoutConfirm: true,
        });
      }
      else {
        //item.maxQty = e;
        this.isInvalidMinMax = false;
      }
    }
  }

  //#region  submit
  isCopySelection: boolean = false;

  private submit(e: string) {
    if (!this._stockLicense?.advancedInventory) {
      const selectedType = this._form.get('itemtype')?.value;
      const typeId = selectedType?.id;
      if (typeId && typeId !== 1 && typeId !== 4) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Advanced item types are restricted because StockAdvancedInventory license is disabled.',
        });
        return false;
      }
    }

    if (this._currentUser.isEnterprise) {
      if (this._currentUser.isEnterprise && this._selectedAccounts.length === 0) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please select account(s) to continue.',
        });

        return false;
      }
      else {
        var tmpAccountSites = this._selectedAccounts.filter((x: any) => x.siteId != -1);

        if (tmpAccountSites.length != this._selectedAccounts.length) {
          this._layoutComponent.openPopup({
            title: 'Validation',
            message: 'Please select the site(s) of the selected account(s) to continue.',
          });

          return false;
        }
      }
    }

    if (this._form.invalid && this._customValidation.find((x: any) => !x.value)) {
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
      this._invalidForm = true;
      this._invalidSubmit = true;
    }
    else if (this._form.invalid) {
      if (this._form.value.minqty > this._form.value.maxqty) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Cannot insert min quantity > max quantity',
          withoutConfirm: true,
        });

        return false;
      }

      this._invalidForm = true;
    }
    else if (this._customValidation.find((x: any) => !x.value)) {
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
      this._invalidSubmit = true;
      this._invalidForm = true;
    }
    else if (this.isInvalidMinMax) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Cannot insert min quantity > max quantity',
        withoutConfirm: true,
      });

      return false;
    }
    else if (this._stockItemLocationMinMax && this._stockItemLocationMinMax.some(item => !item.smsNotifyUser && !item.emailNotifyUser)) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'For each location in Location Min/Max, at least one of (SMS Notify User) or (Email Notify User) must be selected.',
        withoutConfirm: true,
      });

      return false;
    }
    else {
      // work with custom fields
      if (this._customFieldsValue) {
        this._customFieldsValue.forEach((elementy: any) => {
          this._customFieldsDictionary[elementy.Key] = elementy.Value;
        });
      }

      this._invalidForm = false;
      this._invalidSubmit = false;
      const model = this._form.value;
      model['customFieldsValue'] = this._customFieldsDictionary;
      model['accountSites'] = [];
      var tmpAccountSites = this._selectedAccounts.filter((x: any) => x.siteId != -1);

      tmpAccountSites.forEach((item) => {
        if (model['accountSites'].filter((x: any) => x.siteId == item.siteId && x.accountId == item.accountId).length == 0) {
          model['accountSites'].push(item);
        }
      });

      model['itemTypeId'] = this._form.get('itemtype')?.value?.id > 0 ? this._form.get('itemtype')?.value?.id : null;
      model['costTypeId'] = this._form.get('costtype')?.value?.id > 0 ? this._form.get('costtype')?.value?.id : null;
      model['categoryId'] = model.category && model.category.id > 0 ? model.category.id : null;
      model['defaultLocationId'] = model.defaultLocation ? model.defaultLocation.id : null;
      // model['receiveUnitOfMeasureId'] = model.receiveunitofmeasure ? model.receiveunitofmeasure.id : null;
      // model['inventoryUnitOfMeasureId'] = model.inventoryunitofmeasure?.id;
      // model['issueUnitOfMeasureId'] = model.issueunitofmeasure?.id;
      // model['issueUnitOfMeasureId'] = model.issueunitofmeasure?.id;
      model['IsTaxable'] = this.IsTaxable;
      model['costInfoId'] = this._model.costInfo?.id;
      model['receiveUnitOfMeasureId'] = this._form.get('receiveunitofmeasure')?.value?.id > 0 ? this._form.get('receiveunitofmeasure')?.value?.id : null;
      model['inventoryunitofmeasureId'] = this._form.get('inventoryunitofmeasure')?.value?.id > 0 ? this._form.get('inventoryunitofmeasure')?.value?.id : null;
      model['issueunitofmeasureId'] = this._form.get('issueunitofmeasure')?.value?.id > 0 ? this._form.get('issueunitofmeasure')?.value?.id : null;

      model['costInfo'] = {
        id: this._model.costInfo?.id,
        cost: model.cost,
        isCalculatedPrice: model.calprice,
        markupPercent: model.pricemarkuppercent,
        markupNumber: model.pricemarkupnumber,
        isFixedPrice: model.fixedprice,
        fixedUnitPrice: model.fixedunitprice,
        isTaxable: model.IsTaxable,
      };

      if (this._pageState == PageState.ADD || this._pageState == PageState.COPY) {
        model['costInfo'].id = 0;
        model['costInfoId'] = 0;
      }

      model['stockItemLeads'] = [
        {
          stockitemleadtime: model.leadtime,
          stockitemleadinterval: model.leadvar,
          stockitemleadtimeduration: model.leadtimeduration,
        },
      ];

      if (this._pageState == PageState.ADD || this._pageState == PageState.COPY) {
        this._stockItemVendor.forEach((element: any) => {
          element.id = 0;
        });
      }

      model['stockItemVendors'] = this._stockItemVendor;
      model['stockLocationsMinMax'] = this._stockItemLocationMinMax;

      if (this._pageState == PageState.ADD || this._pageState == PageState.COPY) {
        this._stockItemLocationMinMax.forEach((element: any) => {
          element.id = 0;

          if (!element.minQty) {
            element.minQty = 0;
          }

          if (!element.maxQty) {
            element.maxQty = 0;
          }
        });
      }
      model['stockItemAlternateCodes'] = '';
      model['StockItemAlternates'] = this._stockAlternateGridData;
      model['StockItemAlternatesDelete'] = this.stockItemAlternatesDelete;
      model['iskit'] = this._isKit;

      model['isShopping'] = this._isShopping;
      model['shoppingUM'] = this._shoppingUM;

      if (this._isKit) {
        this._selectedListKit.forEach((element: any) => {
          this._selectedKit = {}
          this._selectedKit.StockItemId = element.id;
          this._selectedKit.DetailStockItemId = element.id;
          this._selectedKit.DefaultLocationId = element.defaultLocationId;
          this._selectedKit.Quantity = element.quantity;
          this._selectedKit.ExtendedCost = element.extendedCost;

          this.stockItemKitDetails.push(this._selectedKit)
        });

        model['stockItemKitDetails'] = this.stockItemKitDetails;

        this._selectedListkitDetail.forEach((element: any) => {
          this._selectedKit = {}
          // this._selectedKit.StockItemKitDetailId=element.primaryStockId;
          this._selectedKit.StocckItemKitRelatedId = element.primaryStockId;
          this._selectedKit.SubDetailStockItemId = element.stockId;
          this._selectedKit.DefaultLocationId = element.defaultLocationId;
          this._selectedKit.Quantity = element.quantity;
          this.stockItemSubKitDetails.push(this._selectedKit)
        });

        model['stockItemSubKitDetail'] = this.stockItemSubKitDetails;
      }

      model['applyTotalExtendCost'] = this._applayTotalExtendedCost;

      let _stockItemFiles: StockItemFile[] = [];
      _stockItemFiles.push(...this._stockItemFilesPics);
      _stockItemFiles.push(...this._stockItemFilesDoc);
      _stockItemFiles.push(...this._stockItemFilesVideo);
      model['stockItemFiles'] = [..._stockItemFiles];
      model["siteId"] = this._siteSelected?.id;
      if (this._model != null && this._model.id != null) {
        this._stockItemsService.updateStockItem(this._model.id, model).subscribe((response: any) => {
          if (response.data != null && response.data['message'] != null) {
            if (response.data['message'] != '') {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response.data['message'],
                withoutConfirm: true,
              });
            }
            if (response.extraData.stockItemAlternates != undefined && response.extraData.stockItemAlternates != null) {
              this.loadStockAlternateAfterUpdate(response.extraData.stockItemAlternates);
            }

            if (response.data['close'] != null) {
              if (response.data['close'] == true) {
                if (e === 'saveAndClose') {
                  model.id = this._model.id;
                  this._closeForm(model);
                }
                else if (e === 'saveAndCopy') {
                  this.copyModelId = this._model.id;
                  this._model.id = null;
                  this._form.controls.number.setValue(null);
                  this.isCopySelection = true;
                  this._pageState = PageState.ADD;
                  this.loadCustomFields();
                }
                else if (e === 'saveAndNew') {
                  this._openForm(this._page);
                  //this._closeForm();
                }
              }
              else {
                return false;
              }
            }
          }
          //  this._closeForm();
        });
      }
      else {
        this._stockItemsService.createStockItem(model).subscribe((response: any) => {
          if (response.data != null && response.data['message'] != null) {

            if (!this._currentUser.isEnterprise) {

              this.note.createNote(response.data.responseId);
            }

            if (response['message'] != '') {

              if (this._isKit) {
                this._stockItemsService.isAddKitting.emit(response.data.extraData);
              }

              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response.data['message'],
                withoutConfirm: true,
              });
            }

            if (response.data['close'] != null) {

              if (response.data['close'] == true) {

                if (e === 'saveAndClose') {

                  model.id = response.returnId
                  this._closeForm(model);
                }
                else if (e === 'saveAndCopy') {
                  this._form.controls.number.setValue(null);
                }
                else if (e === 'saveAndNew') {
                  this._openForm(this._page);
                }
                else {
                  this._model.id = response.data.responseId ? response.data.responseId : response.returnId;
                  this._pageState = PageState.EDIT;
                  this._stockItemsService.getStockItem(this._model.id).subscribe((model) => {
                    this._model = model
                  });
                }
                //this._closeForm();
              }
              else {
                return false;
              }
            }
          }
          // this._closeForm();
        });
      }
    }
  }

  //#endregion
  getLabel(objectCode: any, tabid: any = null) {
    if (this._gridFieldText) {
      if (this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)) {
        var result = this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode);
      }
      else {
        result = null;
      }

      return result ? result : null;
    }
  }

  getSysReceiveSettings() {
    this._sysReceivesService.getSysReceive().subscribe((data) => {
      this._sysReceiveSettings = data;
    });
  }

  formStatus(isInvalid: boolean) {
    this._custominvalidForm = isInvalid;
  }

  getFormTabs() {
    this._gridFields.getformTabsByPage(this._page).subscribe((x: any) => {
      if (!x.find((tab: any) => tab.name === 'Videos')) {
        const picturesTab = x.find((tab: any) => tab.name === 'Pictures');
        if (picturesTab) {
          const videosTab = {
            id: -2, // Use negative ID for frontend-added tabs
            name: 'Videos',
            order: picturesTab.order + 0.5, // Place after Pictures
            isCustom: false,
            page: this._page
          };
          x.push(videosTab);
          // Re-sort by order
          x.sort((a: any, b: any) => a.order - b.order);
        }
      }
      this._dataTabs = x;
      this._dataTabsSelected = x;
      this._userNewDataTabs = x;
      //this.sortProduct(p => p.order, "ASC");
    });
  }

  getSystemFields() {
    this._gridFields.getSystemFieldsByPage(this._page).subscribe((x: any) => {
      this._systemFields = x;
      this._editedSystemFields = x;
    });
  }

  getSystemFieldsAndCustomFields() {
    this._gridFields.getSystemFieldsByPage(this._page).subscribe((x: any) => {
      this._systemFields = x;
      this._editedSystemFields = x;
      this.loadCustomFields(this._model?.id?.toString());
      //this.setMandatoryFields();
    });
  }

  dataMove(newLocData: any, oldLocData: any) {
    const sysF: any[] = this._systemFields;
    const sysFClone: any[] = [];

    sysF.forEach((element: any) => {
      sysFClone.push(Object.assign({}, element));
    });

    this._systemFields.find((x) => x.id === oldLocData.id).formOrder = sysFClone.find((x) => x.id === newLocData.id).formOrder;
    this._systemFields.find((x) => x.id === newLocData.id).formOrder = sysFClone.find((x) => x.id === oldLocData.id).formOrder;

    this._editedSystemFields = this._systemFields;
  }

  dragEnd() {
    this._gridFields.updatedSystemFieldReorder(this._editedSystemFields).subscribe((x: any) => {
      this._systemFields = x;
      this._editedSystemFields = x;
    });
  }

  getAuth() {
    // this._gridFields.getFileAuthorization(this._auth, this._currentUser.appRole.id)
    this._gridFields.getFieldsAuthorization(this._page, this._currentUser.appRole.id).subscribe((x: GridFieldAuthorization[]) => {
      this._gridFieldAuth = x;
    });
  }

  getLocationAuth() {
    this._gridFields.getFileAuthorization('mnuLocation', this._currentUser.appRole.id).subscribe((x: GridFieldAuthorization) => {
      this._locationAuth = x;
    });
  }

  getAuthByLabel(objectCode: any) {
    if (this._gridFieldAuth) {
      if (this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)) {
        var result = this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode);
      }
      else {
        result = null;
      }

      return result ? result : new GridFieldAuthorization();
    }
  }

  requiredSystemTabs: any = [];

  setMandatoryFields() {
    //this.getSystemFields();
    //this.loadCustomFields(this._model?.id?.toString());
    this._requiredFieldNames = [];
    this._requiredFields = [];
    this.requiredSystemTabs = [];
    this._customValidation = [];
    setTimeout(() => {
      for (let item of this._systemFields) {
        if (item.gridFieldText?.isRequired && item.page?.trimEnd('') == this._page) {
          this._requiredFields.push(item);
        }
      }

      for (let item2 of this._customFields) {
        if (item2) {
          for (let item3 of item2) {
            if (item3.isRequired && item3.formTab?.page == this._page) {
              this._requiredFields.push(item3);
            }
          }
        }
      }

      this._requiredFields.forEach((element) => {
        if (!element.isCustomField && element.isCustomField == null) {
          var tabName = element.formTab;
          this._requiredFieldNames.push(tabName);
        }
        else {
          if (element.formTabId) {
            let SystemFieldTab = this._dataTabs.find((x) => x.id == element.formTabId);
            if (SystemFieldTab) this.requiredSystemTabs.push(SystemFieldTab);
          }
        }
      });

      let tabElementList = this.navTrigger.nativeElement.querySelector('ul');

      Array.from(tabElementList.children).forEach((child: any) => {
        child.classList.remove('mendatoryTab');
      });

      Array.from(tabElementList.children).forEach((child: any) => {
        if (child.firstChild.innerText == 'General') {
          child.classList.add('mendatoryTab');
        }

        if (child.firstChild.innerText == 'Costing') {
          child.classList.add('mendatoryTab');
        }

        if (this._requiredFieldNames.find((x) => x.name === child.firstChild.innerText && (x.page ? x.page.trimEnd('') == this._page : x.formTab.page.trimEnd('') == this._page))) {
          child.classList.add('mendatoryTab');
        }

        if (this.requiredSystemTabs.find((x: any) => x.name === child.firstChild.innerText)) {
          child.classList.add('mendatoryTab');
        }
      });

      this._requiredFields.forEach((element) => {
        if (element.customFieldType) {
          this._customRequiredFields.push(element);

          let thisvalue = element.customFieldsData.filter((x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId)).length > 0
            ? element.customFieldsData.filter((x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId))[0].value
            : '';

          this._customValidation.push({
            name: element.name,
            value: thisvalue,
            tabName: element.formTab?.name,
          });
        }
      });
    }, 500);
  }

  getLicense() {
    this._securityService.getLicense().subscribe((liscence: any) => {
      this._stockLicense = liscence?.stock || liscence;

      if (!this._stockLicense?.kitting) {
        this._itemStatus = this._itemStatus.filter((obj) => obj.id !== 'assemble');
      }

      this._isShopper = liscence?.general?.shoppingCart && this._currentUser.person?.isShopping;
    });

    this._assembleSettingsService.getAssembleSettings().subscribe((res) => {
      if (res != undefined && res != null) {
        this._kittingEnabled = res.kittingEnabled ?? false;
        this._substituteItems = res.substituteEnabled ?? false;

        if (!this._kittingEnabled) {
          this._itemStatus = this._itemStatus.filter((obj) => obj.id !== 'assemble');
        }
      }
    });

    this._gridFields.getFileAuthorization('mnuKitting', this._currentUser.appRole.id).subscribe((x: GridFieldAuthorization) => {
      this._kittingAuth = x;

      if (!this._kittingAuth?.canView) {
        this._itemStatus = this._itemStatus.filter((obj) => obj.id !== 'assemble');
      }
    });
  }

  addCustomFieldsToForm() {
    // this._customFields.forEach((element: any) => {
    //   if(element.formtab.page === this._page){
    //     let customControl = FormControl(element.)
    //     this._form.addControl(customControl)
    //   }
    // });
  }

  getCustomForm(event: any) {
    this._customForm = event;
  }

  _setPrimaryPic(data: any) {
    this._stockItemFilesPics.forEach((element: any) => {
      if (element !== data) {
        element.stockitemfileisprimary = false;
      }
    });
  }

  _setPrimaryVendor(data: any) {
    this._stockItemVendor.forEach((element: any) => {
      if (element !== data) {
        element.isPreferred = false;
      }
    });
  }

  _getUpcInfo() {
    this._stockItemsService.getUpcInfo(this._form.value.number).subscribe((x: any[]) => {
      if (x.length > 0) {
        this._upcGrid = x;
        this._isUpc = true;
      } else {
        this._layoutComponent.openPopup({
          title: 'Not Found',
          message: 'No Data Found for this Barcode!',
          withoutConfirm: true,
        });
      }
    });
  }

  _closeUpcWindow() {
    this._isUpc = false;
  }

  _returnSelectedUpcHandler() {
    this._form.controls.description.setValue(this._upcGrid[0].description);
    this._form.controls.generaldescription.setValue(this._upcGrid[0].description);
    this._form.controls.cost.setValue(this._upcGrid[0].cost);
    this._isUpc = false;
  }

  _getUsers() {
    this._userService.getActiveUsersList().subscribe((x: any) => {         //.getUsersList()
      this._users = x;
    });
  }

  _onSMSChange(event: any, item: any) {
    item.smsNotifyUserId = event.id;
  }

  _onEmailChange(event: any, item: any) {
    item.emailNotifyUserId = event.id;
  }

  getStateString(siteShip: any) {
    let accounts = '';
    let counter = 0;

    siteShip.forEach((element: any) => {
      if (counter > 0) {
        accounts += ', ';
      }

      accounts += element.address.state;
      counter++;
    });

    return accounts;
  }

  getCountryString(siteShip: any) {
    let accounts = '';
    let counter = 0;
    siteShip.forEach((element: any) => {
      if (counter > 0) {
        accounts += ', ';
      }
      accounts += element.address.country;
      counter++;
    });

    return accounts;
  }

  getZipString(siteShip: any) {
    let accounts = '';
    let counter = 0;
    siteShip.forEach((element: any) => {
      if (counter > 0) {
        accounts += ', ';
      }
      accounts += element.address.zip;
      counter++;
    });

    return accounts;
  }

  getCityString(siteShip: any) {
    let accounts = '';
    let counter = 0;
    siteShip.forEach((element: any) => {
      if (counter > 0) {
        accounts += ', ';
      }
      accounts += element.address.city;
      counter++;
    });

    return accounts;
  }

  getAddress1String(siteShip: any) {
    let accounts = '';
    let counter = 0;
    siteShip.forEach((element: any) => {
      if (counter > 0) {
        accounts += ', ';
      }
      accounts += element.address.addressLine1;
      counter++;
    });

    return accounts;
  }

  getAddress2String(siteShip: any) {
    let accounts = '';
    let counter = 0;
    siteShip.forEach((element: any) => {
      if (counter > 0) {
        accounts += ', ';
      }
      accounts += element.address.addressLine2;
      counter++;
    });

    return accounts;
  }

  canAccess(scope: string, operation: string): boolean {
    return this._securityService.hasPermission(null, `${scope}-${operation}`);
  }

  _getCostTypes() {
    return this._form.controls['itemtype'].value.name == 'Standard'
      ? this._costTypes?.filter((x) => x.code != 'Actual')
      : this._costTypes;
  }

  _selectLocationsHandler(): void {
    this._showLocationsGrid = true;
  }

  _selecCategoryHandler(): void {
    this._showCategoryGrid = true;
  }
  _selecIssueUOMHandler(): void {
    this._showIssueUOMGrid = true;
  }

  _selecInvebtoryUOMHandler(): void {
    this._showInvebtoryUOMGrid = true;
  }
  _selectReceiveUOMHandler(): void {
    this._showReceiveUOMGrid = true;
  }
  _closeLocationsWindow(): void {
    this._showLocationsGrid = false;
  }
  _closeCategoryWindow(): void {
    this._showCategoryGrid = false;
  }

  _closeIssueUOMWindow(): void {
    this._showIssueUOMGrid = false;
  }

  _closeImvebtoryUOMWindow(): void {
    this._showInvebtoryUOMGrid = false;
  }
  _closeReceiveUOMWindow(): void {
    this._showReceiveUOMGrid = false;
  }

  _onLocationRowSelectionChanges(e: any[]) {
    this._selectedLocations = [];
    e.forEach((item) => {
      this._selectedLocations.push(item);
    });
  }

  _onUOMRowSelectionChanges(e: any[]) {
    this._selectedUOM = [];
    e.forEach((item) => {
      this._selectedUOM.push(item);
    });
  }

  _onCategoryRowSelectionChanges(e: any[]) {
    this._selectedCategories = [];
    e.forEach((item) => {
      this._selectedCategories.push(item);
    });
  }

  _returnSelectedLocationsHandler(e: any[]): void {
    this._showLocationsGrid = false;
    this._selectedLocations.forEach((item: LocationSummary) => {
      //this._form.controls.location.setValue(item);
      this._form.controls['defaultLocation'].setValue(item);
    });

    this.locationValueChange(e);
  }

  _returnSelectedCategorysHandler(e: any[]): void {
    this._showCategoryGrid = false;
    this._selectedCategories.forEach((item: CategorySummary) => {
      this._form.controls['category'].setValue(item);
    });
    //this.locationValueChange(e);
  }

  _returnSelectedIssuUOMsHandler(e: any[]): void {
    this._showIssueUOMGrid = false;
    this._selectedUOM.forEach((item: UnitOfMeasureSummary) => {
      this._form.controls['issueunitofmeasure'].setValue(item);
    });
    //this.locationValueChange(e);
  }
  _returnSelectedInventoryUOMsHandler(e: any[]): void {
    this._showInvebtoryUOMGrid = false;
    this._selectedUOM.forEach((item: UnitOfMeasureSummary) => {
      this._form.controls['inventoryunitofmeasure'].setValue(item);
    });
    //this.locationValueChange(e);
  }
  _returnSelectedReceiveUOMsHandler(e: any[]): void {
    this._showReceiveUOMGrid = false;
    this._selectedUOM.forEach((item: UnitOfMeasureSummary) => {
      this._form.controls['receiveunitofmeasure'].setValue(item);
    });
    //this.locationValueChange(e);
  }

  _returnSelectedCategoryHandler(e: any[]): void {
    this._showCategoryGrid = false;
    this._selectedLocations.forEach((item: LocationSummary) => {
      //this._form.controls.location.setValue(item);
      this._form.controls['defaultLocation'].setValue(item);
    });
    this.locationValueChange(e);
  }

  _getCategories = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    if (this._currentUser.isEnterprise) {
      model.accountIds = this._selectedAccountIds;
    }

    return this._categoriesService.getCategories(params, model);
  };

  _getLocations = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    if (model != null && model.filter != null) {
      model.screenSiteId = this._siteSelected?.Id > 0 ? this._siteSelected?.Id : 0;

      return this._locationsService.getLocations(params, model);
    }
    //this._stockItemsService.getStockItems();
  };

  locationValueChange(event: any) {
    if (event) {
      this.LoadStockItemQuantityMinMax();
      this.LoadData();
    }
  }

  _loadVendorsDD() {
    return this._vendorsService.getVendorsListing().subscribe((data: any) => {
      data.unshift({ id: -1, code: '<No Vendor>', name: '<No Vendor>' }); //add on top
      this._vendors = data;
      this._vendorsFiltered = data;
    });
  }
  _doDownloadFile(event: any) {
    let filePath = this._storagePath + event.file.stream;
    var a = document.createElement('a');
    a.href = filePath;
    document.body.appendChild(a);
    a.click();
    a.target = '_blank';
    document.body.removeChild(a);
  }
  _loadFormSites(IsEdit: boolean = false, SavedSite: any = null) {
    this._multiSitesService.getAllSites().subscribe((data: any) => {
      this._sites = data || [];
      this._sitesFiltered = this._sites;

      this.initAllSitesDropDown(IsEdit, SavedSite);

    });
  }
  initAllSitesDropDown(isEdit: boolean = false, SavedSite: any = null) {
    super.initAllSitesDropDown(isEdit, SavedSite);
    this._loadLocationsDD(this._siteSelected?.id);
    this.GetStockItemForBill(this._siteSelected?.id);
  }

  _handleSitesChange(event: any) {
    super._handleSitesChange(event);
    this._loadLocationsDD(this._siteSelected?.id);
    this.GetStockItemForBill(this._siteSelected?.id);
  }

  //#endregion
  getAccountNames(accounts: any[]): string {
    if (!accounts || !Array.isArray(accounts)) return '';
    const names = accounts
      .map(d => d?.account?.name ?? d?.name)
      .filter((name): name is string => typeof name === 'string' && name.trim().length > 0);
    return Array.from(new Set(names)).join(', ');
  }

  getSiteDisplay(item: any, field?: string): string {
    if (!item) return 'All Sites';

    const isCode = field ? (field === 'site.code' || field.endsWith('.id') || field.endsWith('.code')) : false;

    if (item.site) {
      const val = isCode ? (item.site.code ?? item.site.id) : item.site.name;
      if (val !== null && val !== undefined && String(val).trim() !== '') {
        return String(val);
      }
    }

    if (item.stockItemSites && Array.isArray(item.stockItemSites) && item.stockItemSites.length > 0) {
      const sites: string[] = [];
      for (const element of item.stockItemSites) {
        if (element?.site) {
          const val = isCode ? (element.site.code ?? element.site.id) : element.site.name;
          if (val !== null && val !== undefined && String(val).trim() !== '') {
            sites.push(String(val).trim());
          }
        }
      }
      const uniqueSites = Array.from(new Set(sites));
      if (uniqueSites.length > 0) {
        return uniqueSites.join(', ');
      }
    }

    return 'All Sites';
  }

  _closeStockItemNotesWindow() {
    this._showStockItemFileNotes = false;
  }

  _showStockItemNotesWindow(id: number) {
    this._stockItemsService.getStockItem(id).subscribe((model: any) => {
      this._stockItemNotesModel = model;
      this._showStockItemFileNotes = true;
    });
  }

  onMinQtyLostFocus(e: any) {
    if (e.minQty != null && e.maxQty != null) {
      if (e.minQty > e.maxQty) {
        e.minQty = e.maxQty
      }
    }
  }

  onMaxQtyLostFocus(e: any) {
    if (e.minQty != null && e.maxQty != null) {
      if (e.maxQty < e.minQty) {
        e.maxQty = e.minQty
      }
    }
  }
}
